import MyInput from '../../components/ui/MyInput';
import deleteX from '../../assets/img/deleteX.svg';
import { useEffect, useState } from 'react';
import PrimaryButton from '../../components/ui/PrimaryButton';
import {
  SVG_Add_Square_Bold,
  SVG_Traffic_Bold,
  SVG_Trash_Bin_2_Bold,
  SVG_Trash_Bin_2_Linear,
  SVG_Trash_Bin_2_Outline,
  SVG_Trash_Bin_Minimalistic_2_Bold,
} from '@dev-mobligo/iconpack';
import { useDispatch } from 'react-redux';
import systemSlice from '../../redux/systemSlice';
import { useNavigate } from 'react-router-dom';
import allTabs from '../DashboardTabs';
import LayeredDashboardHeader from '../LayeredDashboardHeader';
import CreateAction from '../../components/operational/createAction';
import useCustomNavigate from '../../components/operational/goBack';
import { v4 as uuid } from 'uuid';
import { TreeSelect } from 'primereact/treeselect';
import store from '../../redux/store';
import { useSelector } from 'react-redux';
import Table from '../../components/ui/Table';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import AddLanguage from './AddLanguage';
import countryCodes from '../../utils/countryCodes.json';
import { Dropdown } from 'primereact/dropdown';

const LanguageAndRegions = ({ tab }) => {
  const navigate = useNavigate();
  const goBack = useCustomNavigate(tab);
  const language = useSelector(state => state.systemSlice.language);
  const [isActive, setIsActive] = useState(false);
  const [languageAndRegions, setLanguageAndRegions] = useState([]);
  const [languages, setLanguages] = useState([]);
  const [themeVariants, setThemeVariants] = useState([]);
  const [selectedThemeVariant, setSelectedThemeVariant] = useState([]);

  const saveThemeVariants = async () => {
    const themeVariantArray = selectedThemeVariant.map((selectedThemeVariant, index) => {
      return { themeVariantId: selectedThemeVariant?.code, localizationId: languageAndRegions[index]?.id };
    });
    const response = await CreateAction({
      method: 'patch',
      path: `/updateLocalizations`,
      showPreLoader: true,
      isFileUploading: false,
      data: themeVariantArray,
    });
  };

  const bodyLanguage = rowData => {
    return <div className="flex flex-row flex-wrap min-w-[200px]">{rowData.language?.language}</div>;
  };
  const bodyCurrency = rowData => {
    return (
      <div className="flex flex-row flex-wrap min-w-[200px]">
        {rowData.currency?.code} ({rowData.currency?.symbol})
      </div>
    );
  };

  const bodyRegion = rowData => {
    const regions = rowData?.regions;

    return (
      <div className="flex flex-row flex-wrap gap-[10px]">
        {regions?.map(region => {
          return (
            <div className="border-1 border-gray-200 rounded-md p-1 text-sm flex flex-row gap-[5px]">
              {region?.emoji}
              {'\t'}
              {region?.locationTranslations?.[language]}
            </div>
          );
        })}
      </div>
    );
  };

  const bodyVariant = rowData => {
    return (
      <div className="flex flex-row flex-wrap w-[200px]">
        <Dropdown
          filter
          placeholder="Lütfen bir tema dili seçiniz."
          value={selectedThemeVariant[rowData.index]}
          className="w-full"
          options={themeVariants}
          optionLabel="name"
          onChange={e => {
            setSelectedThemeVariant(state => {
              const newState = [...state];
              newState[rowData.index] = e.value;
              return newState;
            });
          }}
        ></Dropdown>
      </div>
    );
  };

  const getLanguageAndRegions = async (countryData, isSync, themeVariantData) => {
    const response = await CreateAction({
      method: 'get',
      path: isSync ? '/syncLocalizations' : '/getLocalizations',
      showPreLoader: true,
      isFileUploading: false,
    });

    if (response?.error) {
      return navigate('/dashboard/language-settings/');
    }

    const responseData = response.result?.resultData;
    const responseLanguageAndRegions = responseData;
    const languageArray = [];
    const newSelectedThemeVariants = [];
    if (!responseLanguageAndRegions) return;
    const responseRegions = responseLanguageAndRegions?.map((responseLanguageAndRegion, index) => {
      const regions = responseLanguageAndRegion?.regions?.map(region => {
        const regionData = countryData?.find(data => data.iso2 === region);
        return regionData;
      });

      const language = countryCodes?.find(countryCode => countryCode.iso2 === responseLanguageAndRegion.locale);
      languageArray.push(language?.iso2);
      const currentSelectedThemeVariant = themeVariantData.find(
        themeVariant => themeVariant.code === responseLanguageAndRegion.themeVariantId,
      );
      newSelectedThemeVariants.push(currentSelectedThemeVariant);
      return {
        id: responseLanguageAndRegion.id,
        regions,
        language: language,
        currency: { code: responseLanguageAndRegion.currencyCode, symbol: responseLanguageAndRegion.currencySymbol },
        index: index,
      };
    });

    setSelectedThemeVariant(newSelectedThemeVariants);

    setLanguages(languageArray);
    setLanguageAndRegions(responseRegions);
  };

  const getListCountry = async isSync => {
    const response = await CreateAction({
      method: 'get',
      path: `/listCountry`,
      showPreLoader: true,
      isFileUploading: false,
      hideToastMessages: true
    });


    const responseData = response?.result?.resultData;
    const newThemeVariants = await getThemeVariants();
    getLanguageAndRegions(responseData || initialCountryData, isSync, newThemeVariants);
  };

  const getThemeVariants = async () => {
    const response = await CreateAction({
      method: 'get',
      path: `/themeVariants`,
      showPreLoader: true,
      isFileUploading: false,
    });

    if (response?.error) {
      return navigate('/dashboard/language-settings');
    }
    const responseData = response?.result?.resultData;
    if (!responseData) return navigate('/dashboard/language-settings');
    const newThemeVariants = responseData?.map(themeVariant => {
      return {
        name: themeVariant?.name,
        code: themeVariant?.id,
      };
    });
    setThemeVariants(newThemeVariants);
    return newThemeVariants;
  };

  useEffect(() => {
    getListCountry();
  }, []);
  return (
    <>
      <LayeredDashboardHeader
        onSave={() => {
          saveThemeVariants();
        }}
        tab={tab}
      ></LayeredDashboardHeader>
      <div className="w-full h-[calc(100dvh-70px)] overflow-auto scrollbar-y-visible">
        <div>
          <div className="p-[20px] flex items-center justify-center 2xl:p-[40px] flex-col  mx-auto">
            <div className="bg-white p-[20px] rounded-[10px] 2xl:p-[40px]  w-[100%]">
              <div>
                <div
                  className="flex flex-row items-center"
                  style={{ display: 'flex', justifyContent: 'space-between' }}
                >
                  <div className="flex flex-col ">
                    <div className="text-[#5E5873] text-[18px] font-semibold">Lokalizasyon Ayarları</div>
                    {/* <div className="text-gray-400 text-[14px] font-semibold">123123</div> */}
                  </div>
                  <div className="">
                    {/* <PrimaryButton value={"Yeni Bölge Ekle"} onClick={() => { setData(null); setIsActive(true) }}></PrimaryButton> */}
                    <PrimaryButton
                      value={'Senkronize Et'}
                      onClick={() => {
                        getListCountry(true);
                      }}
                    ></PrimaryButton>
                  </div>
                </div>
                <div className="mt-5">
                  <DataTable
                    emptyMessage="Kayıt Bulunamadı. "
                    value={languageAndRegions}
                    tableStyle={{ minWidth: '50rem' }}
                    rowClassName={''}
                  >
                    <Column field="language" header="Dil" body={bodyLanguage}></Column>
                    <Column
                      field="region"
                      header="Bölgeler"
                      showFilterMatchModes={false}
                      style={{ minWidth: '12rem' }}
                      body={bodyRegion}
                    />
                    <Column
                      field="currency"
                      header="Para Birimi"
                      showFilterMatchModes={false}
                      style={{ minWidth: '4rem' }}
                      body={bodyCurrency}
                    />
                    <Column
                      field="variant"
                      header="Teması"
                      showFilterMatchModes={false}
                      style={{ minWidth: '4rem' }}
                      body={bodyVariant}
                    />
                  </DataTable>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <LayeredDashboardModal isActive={isActive}>
        <AddLanguage languages={languages} data={data} listCountry={listCountry} getLanguageAndRegions={getLanguageAndRegions} setIsActive={setIsActive} tab={{ ...tab, activeTabs: [...tab?.activeTabs, "Dil Ekle"], activeTabTitles: [...tab?.activeTabTitles, "Dil Ekle"] }}></AddLanguage>
      </LayeredDashboardModal> */}
    </>
  );
};

export default LanguageAndRegions;

const initialCountryData = [
  {
    "capital": "",
    "createdAt": 1604406818002,
    "currency": "USD",
    "currencyCode": "USD",
    "currencySymbol": "$",
    "deleted": false,
    "emoji": "🇺🇲",
    "emojiString": "U+1F1FA U+1F1F2",
    "id": "d66b801a-402e-44c9-a6d3-d236768b557a",
    "iso2": "UM",
    "iso3": "UMI",
    "locationTranslations": {
      "de": "United States Minor Outlying Islands",
      "en": "United States Minor Outlying Islands",
      "fr": "Îles Mineures Éloignées Des États-Unis",
      "tr": "ABD Küçük Harici Adaları"
    },
    "name": "United States Minor Outlying Islands",
    "native": "United States Minor Outlying Islands",
    "phoneCode": "1",
    "region": "Americas",
    "subregion": "Northern America",
    "updatedAt": 1658414431369
  },
  {
    "capital": "Charlotte Amalie",
    "createdAt": 1604406818002,
    "currency": "USD",
    "currencyCode": "USD",
    "currencySymbol": "$",
    "deleted": false,
    "emoji": "🇻🇮",
    "emojiString": "U+1F1FB U+1F1EE",
    "id": "e710b8e4-8107-4a6a-b6cf-20394ca22354",
    "iso2": "VI",
    "iso3": "VIR",
    "locationTranslations": {
      "de": "Amerikanische Jungferninseln",
      "en": "U.S. Virgin Islands",
      "fr": "Îles Vierges Des États-Unis",
      "tr": "ABD Virjin Adaları"
    },
    "name": "U.S. Virgin Islands",
    "native": "United States Virgin Islands",
    "phoneCode": "+1-340",
    "region": "Americas",
    "subregion": "Caribbean",
    "updatedAt": 1658414432128
  },
  {
    "capital": "Kabul",
    "createdAt": 1604406817994,
    "currency": "AFN",
    "currencyCode": "AFN",
    "currencySymbol": "Af",
    "deleted": false,
    "emoji": "🇦🇫",
    "emojiString": "U+1F1E6 U+1F1EB",
    "id": "f77a46cf-5d68-47a4-8534-ee07f405723b",
    "iso2": "AF",
    "iso3": "AFG",
    "locationTranslations": {
      "de": "Afghanistan",
      "en": "Afghanistan",
      "fr": "Afghanistan",
      "tr": "Afganistan"
    },
    "name": "Afghanistan",
    "native": "افغانستان",
    "phoneCode": "93",
    "region": "Asia",
    "subregion": "Southern Asia",
    "updatedAt": 1657792794781
  },
  {
    "capital": "Mariehamn",
    "createdAt": 1604406817996,
    "currency": "EUR",
    "currencyCode": "EUR",
    "currencySymbol": "€",
    "deleted": false,
    "emoji": "🇦🇽",
    "emojiString": "U+1F1E6 U+1F1FD",
    "id": "dd32dd69-c94c-41a5-bd9f-f982959cc148",
    "iso2": "AX",
    "iso3": "ALA",
    "locationTranslations": {
      "de": "Alandinseln",
      "en": "Åland Islands",
      "fr": "Îles Åland",
      "tr": "Åland Adaları"
    },
    "name": "Åland Islands",
    "native": "Åland",
    "phoneCode": "+358-18",
    "region": "Europe",
    "subregion": "Northern Europe",
    "updatedAt": 1658414429670
  },
  {
    "capital": "St Peter Port",
    "createdAt": 1604406817998,
    "currency": "GBP",
    "currencyCode": "GBP",
    "currencySymbol": "£",
    "deleted": false,
    "emoji": "🇬🇬",
    "emojiString": "U+1F1EC U+1F1EC",
    "id": "118c24b9-5d10-47c6-a091-262f10b6fe3d",
    "iso2": "GG",
    "iso3": "GGY",
    "locationTranslations": {
      "de": "Guernsey",
      "en": "Guernsey and Alderney",
      "fr": "Guernesey",
      "tr": "Alderney"
    },
    "name": "Guernsey and Alderney",
    "native": "Guernsey",
    "phoneCode": "+44-1481",
    "region": "Europe",
    "subregion": "Northern Europe",
    "updatedAt": 1658414431078
  },
  {
    "capital": "Berlin",
    "createdAt": 1604406817997,
    "currency": "EUR",
    "currencyCode": "EUR",
    "currencySymbol": "€",
    "deleted": false,
    "emoji": "🇩🇪",
    "emojiString": "U+1F1E9 U+1F1EA",
    "id": "2cd09718-8ae7-499e-afab-2206431db314",
    "iso2": "DE",
    "iso3": "DEU",
    "locationTranslations": {
      "de": "Deutschland",
      "en": "Germany",
      "fr": "Allemagne",
      "tr": "Almanya"
    },
    "name": "Germany",
    "native": "Deutschland",
    "phoneCode": "49",
    "region": "Europe",
    "subregion": "Western Europe",
    "updatedAt": 1657792807772
  },
  {
    "capital": "Washington",
    "createdAt": 1604406818002,
    "currency": "USD",
    "currencyCode": "USD",
    "currencySymbol": "$",
    "deleted": false,
    "emoji": "🇺🇸",
    "emojiString": "U+1F1FA U+1F1F8",
    "id": "e2c98147-4a70-4a7e-9df4-51f6aad8b87e",
    "iso2": "US",
    "iso3": "USA",
    "locationTranslations": {
      "de": "Vereinigte Staaten",
      "en": "United States",
      "fr": "États-Unis",
      "tr": "Amerika Birleşik Devletleri"
    },
    "name": "United States",
    "native": "United States",
    "phoneCode": "1",
    "region": "Americas",
    "subregion": "Northern America",
    "updatedAt": 1657792809892
  },
  {
    "capital": "Pago Pago",
    "createdAt": 1604406817996,
    "currency": "USD",
    "currencyCode": "USD",
    "currencySymbol": "$",
    "deleted": false,
    "emoji": "🇦🇸",
    "emojiString": "U+1F1E6 U+1F1F8",
    "id": "2059a196-5dae-4b5a-90e8-82c35a134a9a",
    "iso2": "AS",
    "iso3": "ASM",
    "locationTranslations": {
      "de": "Amerikanisch-Samoa",
      "en": "American Samoa",
      "fr": "Samoa Américaines",
      "tr": "Amerikan Samoası"
    },
    "name": "American Samoa",
    "native": "American Samoa",
    "phoneCode": "+1-684",
    "region": "Oceania",
    "subregion": "Polynesia",
    "updatedAt": 1658414429729
  },
  {
    "capital": "Andorra la Vella",
    "createdAt": 1604406817996,
    "currency": "EUR",
    "currencyCode": "EUR",
    "currencySymbol": "€",
    "deleted": false,
    "emoji": "🇦🇩",
    "emojiString": "U+1F1E6 U+1F1E9",
    "id": "888d5f60-e1c6-486d-ae89-b37dd5c8bdbb",
    "iso2": "AD",
    "iso3": "AND",
    "locationTranslations": {
      "de": "Andorra",
      "en": "Andorra",
      "fr": "Andorre",
      "tr": "Andorra"
    },
    "name": "Andorra",
    "native": "Andorra",
    "phoneCode": "376",
    "region": "Europe",
    "subregion": "Southern Europe",
    "updatedAt": 1657792793640
  },
  {
    "capital": "Luanda",
    "createdAt": 1604406817996,
    "currency": "AOA",
    "currencyCode": "AOA",
    "currencySymbol": "Kz",
    "deleted": false,
    "emoji": "🇦🇴",
    "emojiString": "U+1F1E6 U+1F1F4",
    "id": "16d6f7c3-8373-4d2b-9010-2f3f224c6cb4",
    "iso2": "AO",
    "iso3": "AGO",
    "locationTranslations": {
      "de": "Angola",
      "en": "Angola",
      "fr": "Angola",
      "tr": "Angola"
    },
    "name": "Angola",
    "native": "Angola",
    "phoneCode": "244",
    "region": "Africa",
    "subregion": "Middle Africa",
    "updatedAt": 1657792795527
  },
  {
    "capital": "The Valley",
    "createdAt": 1604406817996,
    "currency": "XCD",
    "currencyCode": "XCD",
    "currencySymbol": "$",
    "deleted": false,
    "emoji": "🇦🇮",
    "emojiString": "U+1F1E6 U+1F1EE",
    "id": "a168d94d-a168-4972-a6d0-facd303c43b3",
    "iso2": "AI",
    "iso3": "AIA",
    "locationTranslations": {
      "de": "Anguilla",
      "en": "Anguilla",
      "fr": "Anguilla",
      "tr": "Anguilla"
    },
    "name": "Anguilla",
    "native": "Anguilla",
    "phoneCode": "+1-264",
    "region": "Americas",
    "subregion": "Caribbean",
    "updatedAt": 1658414430260
  },
  {
    "capital": "",
    "createdAt": 1604406817996,
    "currency": "",
    "currencyCode": "",
    "currencySymbol": "",
    "deleted": false,
    "emoji": "🇦🇶",
    "emojiString": "U+1F1E6 U+1F1F6",
    "id": "0901a14f-5e77-451e-9835-7249b3f53ff2",
    "iso2": "AQ",
    "iso3": "ATA",
    "locationTranslations": {
      "de": "Antarktis",
      "en": "Antarctica",
      "fr": "Antarctique",
      "tr": "Antarktika"
    },
    "name": "Antarctica",
    "native": "Antarctica",
    "phoneCode": "",
    "region": "Polar",
    "subregion": "",
    "updatedAt": 1658414430143
  },
  {
    "capital": "St. John's",
    "createdAt": 1604406817996,
    "currency": "XCD",
    "currencyCode": "XCD",
    "currencySymbol": "$",
    "deleted": false,
    "emoji": "🇦🇬",
    "emojiString": "U+1F1E6 U+1F1EC",
    "id": "d235f025-a7e5-4bb7-891f-e8e11ffba475",
    "iso2": "AG",
    "iso3": "ATG",
    "locationTranslations": {
      "de": "Antigua und Barbuda",
      "en": "Antigua And Barbuda",
      "fr": "Antigua-Et-Barbuda",
      "tr": "Antigua ve Barbuda"
    },
    "name": "Antigua And Barbuda",
    "native": "Antigua and Barbuda",
    "phoneCode": "+1-268",
    "region": "Americas",
    "subregion": "Caribbean",
    "updatedAt": 1657792793380
  },
  {
    "capital": "Buenos Aires",
    "createdAt": 1604406817996,
    "currency": "ARS",
    "currencyCode": "ARS",
    "currencySymbol": "AR$",
    "deleted": false,
    "emoji": "🇦🇷",
    "emojiString": "U+1F1E6 U+1F1F7",
    "id": "da4c541a-d010-4546-bbfe-4052f0689c57",
    "iso2": "AR",
    "iso3": "ARG",
    "locationTranslations": {
      "de": "Argentinien",
      "en": "Argentina",
      "fr": "Argentine",
      "tr": "Arjantin"
    },
    "name": "Argentina",
    "native": "Argentina",
    "phoneCode": "54",
    "region": "Americas",
    "subregion": "South America",
    "updatedAt": 1657792793191
  },
  {
    "capital": "Tirana",
    "createdAt": 1604406817996,
    "currency": "ALL",
    "currencyCode": "ALL",
    "currencySymbol": "L",
    "deleted": false,
    "emoji": "🇦🇱",
    "emojiString": "U+1F1E6 U+1F1F1",
    "id": "f7bd81d4-a3e4-4b05-a519-80336f7d414f",
    "iso2": "AL",
    "iso3": "ALB",
    "locationTranslations": {
      "de": "Albanien",
      "en": "Albania",
      "fr": "Albanie",
      "tr": "Arnavutluk"
    },
    "name": "Albania",
    "native": "Shqipëria",
    "phoneCode": "355",
    "region": "Europe",
    "subregion": "Southern Europe",
    "updatedAt": 1657792795050
  },
  {
    "capital": "Oranjestad",
    "createdAt": 1604406817996,
    "currency": "AWG",
    "currencyCode": "AWG",
    "currencySymbol": "ƒ",
    "deleted": false,
    "emoji": "🇦🇼",
    "emojiString": "U+1F1E6 U+1F1FC",
    "id": "c113c84b-faa5-46e8-bc93-0f8c4af4c686",
    "iso2": "AW",
    "iso3": "ABW",
    "locationTranslations": {
      "de": "Aruba",
      "en": "Aruba",
      "fr": "Aruba",
      "tr": "Aruba"
    },
    "name": "Aruba",
    "native": "Aruba",
    "phoneCode": "297",
    "region": "Americas",
    "subregion": "Caribbean",
    "updatedAt": 1658414430200
  },
  {
    "capital": "Canberra",
    "createdAt": 1604406817996,
    "currency": "AUD",
    "currencyCode": "AUD",
    "currencySymbol": "AU$",
    "deleted": false,
    "emoji": "🇦🇺",
    "emojiString": "U+1F1E6 U+1F1FA",
    "id": "06af4bd5-0919-4d7a-bcd7-33492101880b",
    "iso2": "AU",
    "iso3": "AUS",
    "locationTranslations": {
      "de": "Australien",
      "en": "Australia",
      "fr": "Australie",
      "tr": "Avustralya"
    },
    "name": "Australia",
    "native": "Australia",
    "phoneCode": "61",
    "region": "Oceania",
    "subregion": "Australia and New Zealand",
    "updatedAt": 1657792792284
  },
  {
    "capital": "Vienna",
    "createdAt": 1604406817996,
    "currency": "EUR",
    "currencyCode": "EUR",
    "currencySymbol": "€",
    "deleted": false,
    "emoji": "🇦🇹",
    "emojiString": "U+1F1E6 U+1F1F9",
    "id": "09d73fa4-e215-48f1-923f-7b7590aa6516",
    "iso2": "AT",
    "iso3": "AUT",
    "locationTranslations": {
      "de": "Österreich",
      "en": "Austria",
      "fr": "Autriche",
      "tr": "Avusturya"
    },
    "name": "Austria",
    "native": "Österreich",
    "phoneCode": "43",
    "region": "Europe",
    "subregion": "Western Europe",
    "updatedAt": 1657792794607
  },
  {
    "capital": "Baku",
    "createdAt": 1604406817996,
    "currency": "AZN",
    "currencyCode": "AZN",
    "currencySymbol": "₼",
    "deleted": false,
    "emoji": "🇦🇿",
    "emojiString": "U+1F1E6 U+1F1FF",
    "id": "97c8b1b7-589d-43d7-be61-8eb3586fa8ef",
    "iso2": "AZ",
    "iso3": "AZE",
    "locationTranslations": {
      "de": "Aserbaidschan",
      "en": "Azerbaijan",
      "fr": "Azerbaïdjan",
      "tr": "Azerbaycan"
    },
    "name": "Azerbaijan",
    "native": "Azərbaycan",
    "phoneCode": "994",
    "region": "Asia",
    "subregion": "Western Asia",
    "updatedAt": 1657792794522
  },
  {
    "capital": "Nassau",
    "createdAt": 1604406817996,
    "currency": "BSD",
    "currencyCode": "BSD",
    "currencySymbol": "$",
    "deleted": false,
    "emoji": "🇧🇸",
    "emojiString": "U+1F1E7 U+1F1F8",
    "id": "ee46e92b-36d2-49ed-a7f9-16c2c4256f82",
    "iso2": "BS",
    "iso3": "BHS",
    "locationTranslations": {
      "de": "Bahamas",
      "en": "Bahamas The",
      "fr": "Bahamas",
      "tr": "Bahamalar"
    },
    "name": "Bahamas The",
    "native": "Bahamas",
    "phoneCode": "+1-242",
    "region": "Americas",
    "subregion": "Caribbean",
    "updatedAt": 1657792792743
  },
  {
    "capital": "Manama",
    "createdAt": 1604406817996,
    "currency": "BHD",
    "currencyCode": "BHD",
    "currencySymbol": "BD",
    "deleted": false,
    "emoji": "🇧🇭",
    "emojiString": "U+1F1E7 U+1F1ED",
    "id": "4a08d7d0-865a-442a-be09-0d19bb7a50de",
    "iso2": "BH",
    "iso3": "BHR",
    "locationTranslations": {
      "de": "Bahrain",
      "en": "Bahrain",
      "fr": "Bahreïn",
      "tr": "Bahreyn"
    },
    "name": "Bahrain",
    "native": "‏البحرين",
    "phoneCode": "973",
    "region": "Asia",
    "subregion": "Western Asia",
    "updatedAt": 1657792795617
  },
  {
    "capital": "Dhaka",
    "createdAt": 1604406817996,
    "currency": "BDT",
    "currencyCode": "BDT",
    "currencySymbol": "৳",
    "deleted": false,
    "emoji": "🇧🇩",
    "emojiString": "U+1F1E7 U+1F1E9",
    "id": "2ee7e275-48d7-4890-9a13-a904333a19ef",
    "iso2": "BD",
    "iso3": "BGD",
    "locationTranslations": {
      "de": "Bangladesch",
      "en": "Bangladesh",
      "fr": "Bangladesh",
      "tr": "Bangladeş"
    },
    "name": "Bangladesh",
    "native": "Bangladesh",
    "phoneCode": "880",
    "region": "Asia",
    "subregion": "Southern Asia",
    "updatedAt": 1657792792482
  },
  {
    "capital": "Bridgetown",
    "createdAt": 1604406817996,
    "currency": "BBD",
    "currencyCode": "BBD",
    "currencySymbol": "BBD$",
    "deleted": false,
    "emoji": "🇧🇧",
    "emojiString": "U+1F1E7 U+1F1E7",
    "id": "36eb24bc-a221-46c9-a83e-5c12fecd4c2c",
    "iso2": "BB",
    "iso3": "BRB",
    "locationTranslations": {
      "de": "Barbados",
      "en": "Barbados",
      "fr": "Barbad",
      "tr": "Barbados"
    },
    "name": "Barbados",
    "native": "Barbados",
    "phoneCode": "+1-246",
    "region": "Americas",
    "subregion": "Caribbean",
    "updatedAt": 1657792793292
  },
  {
    "capital": "El-Aaiun",
    "createdAt": 1604406818002,
    "currency": "MAD",
    "currencyCode": "MAD",
    "currencySymbol": "DH",
    "deleted": false,
    "emoji": "🇪🇭",
    "emojiString": "U+1F1EA U+1F1ED",
    "id": "10cd1880-223c-429f-a2b3-7c6e168f28cb",
    "iso2": "EH",
    "iso3": "ESH",
    "locationTranslations": {
      "de": "Westsahara",
      "en": "Western Sahara",
      "fr": "Sahara Occidental",
      "tr": "Batı Sahara"
    },
    "name": "Western Sahara",
    "native": "الصحراء الغربية",
    "phoneCode": "212",
    "region": "Africa",
    "subregion": "Northern Africa",
    "updatedAt": 1658414432765
  },
  {
    "capital": "Minsk",
    "createdAt": 1604406817996,
    "currency": "BYN",
    "currencyCode": "BYN",
    "currencySymbol": "Br",
    "deleted": false,
    "emoji": "🇧🇾",
    "emojiString": "U+1F1E7 U+1F1FE",
    "id": "1b250489-0b19-47fc-beb4-f2c0263c2565",
    "iso2": "BY",
    "iso3": "BLR",
    "locationTranslations": {
      "de": "Belarus",
      "en": "Belarus",
      "fr": "Biélorussie",
      "tr": "Belarus"
    },
    "name": "Belarus",
    "native": "Белару́сь",
    "phoneCode": "375",
    "region": "Europe",
    "subregion": "Eastern Europe",
    "updatedAt": 1657792796646
  },
  {
    "capital": "Brussels",
    "createdAt": 1604406817996,
    "currency": "EUR",
    "currencyCode": "EUR",
    "currencySymbol": "€",
    "deleted": false,
    "emoji": "🇧🇪",
    "emojiString": "U+1F1E7 U+1F1EA",
    "id": "2373d480-6164-4d9d-9999-55ef488d5e0e",
    "iso2": "BE",
    "iso3": "BEL",
    "locationTranslations": {
      "de": "Belgien",
      "en": "Belgium",
      "fr": "Belgique",
      "tr": "Belçika"
    },
    "name": "Belgium",
    "native": "België",
    "phoneCode": "32",
    "region": "Europe",
    "subregion": "Western Europe",
    "updatedAt": 1657792796466
  },
  {
    "capital": "Belmopan",
    "createdAt": 1604406817996,
    "currency": "BZD",
    "currencyCode": "BZD",
    "currencySymbol": "BZ$",
    "deleted": false,
    "emoji": "🇧🇿",
    "emojiString": "U+1F1E7 U+1F1FF",
    "id": "2758c94b-46e5-4daa-a3f3-c70852c28c8a",
    "iso2": "BZ",
    "iso3": "BLZ",
    "locationTranslations": {
      "de": "Belize",
      "en": "Belize",
      "fr": "Belize",
      "tr": "Belize"
    },
    "name": "Belize",
    "native": "Belize",
    "phoneCode": "501",
    "region": "Americas",
    "subregion": "Central America",
    "updatedAt": 1657792796214
  },
  {
    "capital": "Porto-Novo",
    "createdAt": 1604406817996,
    "currency": "XOF",
    "currencyCode": "XOF",
    "currencySymbol": "₣",
    "deleted": false,
    "emoji": "🇧🇯",
    "emojiString": "U+1F1E7 U+1F1EF",
    "id": "e0f836d2-a732-43c7-8559-4db8a7a6e003",
    "iso2": "BJ",
    "iso3": "BEN",
    "locationTranslations": {
      "de": "Benin",
      "en": "Benin",
      "fr": "Bénin",
      "tr": "Benin"
    },
    "name": "Benin",
    "native": "Bénin",
    "phoneCode": "229",
    "region": "Africa",
    "subregion": "Western Africa",
    "updatedAt": 1657792796555
  },
  {
    "capital": "Hamilton",
    "createdAt": 1604406817996,
    "currency": "BMD",
    "currencyCode": "BMD",
    "currencySymbol": "$",
    "deleted": false,
    "emoji": "🇧🇲",
    "emojiString": "U+1F1E7 U+1F1F2",
    "id": "eaf3d021-78f0-4075-9fa0-b05d0b226a96",
    "iso2": "BM",
    "iso3": "BMU",
    "locationTranslations": {
      "de": "Bermuda",
      "en": "Bermuda",
      "fr": "Bermudes",
      "tr": "Bermuda"
    },
    "name": "Bermuda",
    "native": "Bermuda",
    "phoneCode": "+1-441",
    "region": "Americas",
    "subregion": "Northern America",
    "updatedAt": 1658414430086
  },
  {
    "capital": "Abu Dhabi",
    "createdAt": 1604406818002,
    "currency": "AED",
    "currencyCode": "AED",
    "currencySymbol": "د.إ.",
    "deleted": false,
    "emoji": "🇦🇪",
    "emojiString": "U+1F1E6 U+1F1EA",
    "id": "a2bc4db9-6797-4c95-9c42-dd3ced8453c2",
    "iso2": "AE",
    "iso3": "ARE",
    "locationTranslations": {
      "de": "Vereinigte Arabische Emirate",
      "en": "United Arab Emirates",
      "fr": "Émirats Arabes Unis",
      "tr": "Birleşik Arap Emirlikleri"
    },
    "name": "United Arab Emirates",
    "native": "دولة الإمارات العربية المتحدة",
    "phoneCode": "971",
    "region": "Asia",
    "subregion": "Western Asia",
    "updatedAt": 1657792809613
  },
  {
    "capital": "London",
    "createdAt": 1604406818002,
    "currency": "GBP",
    "currencyCode": "GBP",
    "currencySymbol": "£",
    "deleted": false,
    "emoji": "🇬🇧",
    "emojiString": "U+1F1EC U+1F1E7",
    "id": "81e8c878-caea-4c72-80b5-c4ae2a1efa36",
    "iso2": "GB",
    "iso3": "GBR",
    "locationTranslations": {
      "de": "Vereinigtes Königreich",
      "en": "United Kingdom",
      "fr": "Royaume-Uni",
      "tr": "Birleşik Krallık"
    },
    "name": "United Kingdom",
    "native": "United Kingdom",
    "phoneCode": "44",
    "region": "Europe",
    "subregion": "Northern Europe",
    "updatedAt": 1657792804011
  },
  {
    "capital": "Sucre",
    "createdAt": 1604406817996,
    "currency": "BOB",
    "currencyCode": "BOB",
    "currencySymbol": "Bs.",
    "deleted": false,
    "emoji": "🇧🇴",
    "emojiString": "U+1F1E7 U+1F1F4",
    "id": "a6dbdba7-fc93-4c76-9116-eee253ed38bd",
    "iso2": "BO",
    "iso3": "BOL",
    "locationTranslations": {
      "de": "Bolivien",
      "en": "Bolivia",
      "fr": "État Plurinational De Bolivie",
      "tr": "Bolivya"
    },
    "name": "Bolivia",
    "native": "Bolivia",
    "phoneCode": "591",
    "region": "Americas",
    "subregion": "South America",
    "updatedAt": 1657792793896
  },
  {
    "capital": "Sarajevo",
    "createdAt": 1604406817996,
    "currency": "BAM",
    "currencyCode": "BAM",
    "currencySymbol": "KM",
    "deleted": false,
    "emoji": "🇧🇦",
    "emojiString": "U+1F1E7 U+1F1E6",
    "id": "ca13932f-8c0a-4451-b5ae-c93c3085f7e5",
    "iso2": "BA",
    "iso3": "BIH",
    "locationTranslations": {
      "de": "Bosnien und Herzegowina",
      "en": "Bosnia and Herzegovina",
      "fr": "Bosnie-Herzégovine",
      "tr": "Bosna Hersek"
    },
    "name": "Bosnia and Herzegovina",
    "native": "Bosna i Hercegovina",
    "phoneCode": "387",
    "region": "Europe",
    "subregion": "Southern Europe",
    "updatedAt": 1657792795792
  },
  {
    "capital": "Gaborone",
    "createdAt": 1604406817996,
    "currency": "BWP",
    "currencyCode": "BWP",
    "currencySymbol": "P",
    "deleted": false,
    "emoji": "🇧🇼",
    "emojiString": "U+1F1E7 U+1F1FC",
    "id": "aa87ae94-91b0-45e9-a0c6-4801a69399ee",
    "iso2": "BW",
    "iso3": "BWA",
    "locationTranslations": {
      "de": "Botswana",
      "en": "Botswana",
      "fr": "Botswana",
      "tr": "Botswana"
    },
    "name": "Botswana",
    "native": "Botswana",
    "phoneCode": "267",
    "region": "Africa",
    "subregion": "Southern Africa",
    "updatedAt": 1657792793467
  },
  {
    "capital": "",
    "createdAt": 1604406817996,
    "currency": "NOK",
    "currencyCode": "NOK",
    "currencySymbol": "kr",
    "deleted": false,
    "emoji": "🇧🇻",
    "emojiString": "U+1F1E7 U+1F1FB",
    "id": "66bfc218-a650-4b34-b49d-b3e01941f9fc",
    "iso2": "BV",
    "iso3": "BVT",
    "locationTranslations": {
      "de": "Bouvetinsel",
      "en": "Bouvet Island",
      "fr": "Île Bouvet",
      "tr": "Bouvet Adası"
    },
    "name": "Bouvet Island",
    "native": "Bouvetøya",
    "phoneCode": "",
    "region": "Other",
    "subregion": "",
    "updatedAt": 1658414429966
  },
  {
    "capital": "Brasilia",
    "createdAt": 1604406817996,
    "currency": "BRL",
    "currencyCode": "BRL",
    "currencySymbol": "R$",
    "deleted": false,
    "emoji": "🇧🇷",
    "emojiString": "U+1F1E7 U+1F1F7",
    "id": "43675c6e-e0fd-4730-a751-dee0e7d80496",
    "iso2": "BR",
    "iso3": "BRA",
    "locationTranslations": {
      "de": "Brasilien",
      "en": "Brazil",
      "fr": "Brésil",
      "tr": "Brezilya"
    },
    "name": "Brazil",
    "native": "Brasil",
    "phoneCode": "55",
    "region": "Americas",
    "subregion": "South America",
    "updatedAt": 1657792794952
  },
  {
    "capital": "Diego Garcia",
    "createdAt": 1604406817996,
    "currency": "USD",
    "currencyCode": "USD",
    "currencySymbol": "$",
    "deleted": false,
    "emoji": "🇮🇴",
    "emojiString": "U+1F1EE U+1F1F4",
    "id": "2d7b5997-cc7f-4605-abc0-d308be183b20",
    "iso2": "IO",
    "iso3": "IOT",
    "locationTranslations": {
      "de": "Britisches Territorium im Indischen Ozean",
      "en": "British Indian Ocean Territory",
      "fr": "Territoire Britannique De L'océan Indien",
      "tr": "Britanya Hint Okyanusu Toprakları"
    },
    "name": "British Indian Ocean Territory",
    "native": "British Indian Ocean Territory",
    "phoneCode": "246",
    "region": "Africa",
    "subregion": "Eastern Africa",
    "updatedAt": 1658414429908
  },
  {
    "capital": "Road Town",
    "createdAt": 1604406818002,
    "currency": "USD",
    "currencyCode": "USD",
    "currencySymbol": "$",
    "deleted": false,
    "emoji": "🇻🇬",
    "emojiString": "U+1F1FB U+1F1EC",
    "id": "61f1a58d-c969-4b69-b028-88451c4d2ecf",
    "iso2": "VG",
    "iso3": "VGB",
    "locationTranslations": {
      "de": "Britische Jungferninseln",
      "en": "British Virgin Islands",
      "fr": "Îles Vierges Britanniques",
      "tr": "Britanya Virjin Adaları"
    },
    "name": "British Virgin Islands",
    "native": "British Virgin Islands",
    "phoneCode": "+1-284",
    "region": "Americas",
    "subregion": "Caribbean",
    "updatedAt": 1658414432653
  },
  {
    "capital": "Bandar Seri Begawan",
    "createdAt": 1604406817996,
    "currency": "BND",
    "currencyCode": "BND",
    "currencySymbol": "B$",
    "deleted": false,
    "emoji": "🇧🇳",
    "emojiString": "U+1F1E7 U+1F1F3",
    "id": "f2b09253-36c2-4787-8fcf-2c332f98e80b",
    "iso2": "BN",
    "iso3": "BRN",
    "locationTranslations": {
      "de": "Brunei",
      "en": "Brunei",
      "fr": "Brunei Darussalam",
      "tr": "Brunei"
    },
    "name": "Brunei",
    "native": "Negara Brunei Darussalam",
    "phoneCode": "673",
    "region": "Asia",
    "subregion": "South-Eastern Asia",
    "updatedAt": 1657792792562
  },
  {
    "capital": "Sofia",
    "createdAt": 1604406817996,
    "currency": "BGN",
    "currencyCode": "BGN",
    "currencySymbol": "лв.",
    "deleted": false,
    "emoji": "🇧🇬",
    "emojiString": "U+1F1E7 U+1F1EC",
    "id": "6ad23d1e-ab79-436d-830c-82bac389c92f",
    "iso2": "BG",
    "iso3": "BGR",
    "locationTranslations": {
      "de": "Bulgarien",
      "en": "Bulgaria",
      "fr": "Bulgarie",
      "tr": "Bulgaristan"
    },
    "name": "Bulgaria",
    "native": "България",
    "phoneCode": "359",
    "region": "Europe",
    "subregion": "Eastern Europe",
    "updatedAt": 1657792795319
  },
  {
    "capital": "Ouagadougou",
    "createdAt": 1604406817996,
    "currency": "XOF",
    "currencyCode": "XOF",
    "currencySymbol": "₣",
    "deleted": false,
    "emoji": "🇧🇫",
    "emojiString": "U+1F1E7 U+1F1EB",
    "id": "df1065a7-8fb2-4ea1-8562-308c0f452796",
    "iso2": "BF",
    "iso3": "BFA",
    "locationTranslations": {
      "de": "Burkina Faso",
      "en": "Burkina Faso",
      "fr": "Burkina Faso",
      "tr": "Burkina Faso"
    },
    "name": "Burkina Faso",
    "native": "Burkina Faso",
    "phoneCode": "226",
    "region": "Africa",
    "subregion": "Western Africa",
    "updatedAt": 1657792794266
  },
  {
    "capital": "Bujumbura",
    "createdAt": 1604406817996,
    "currency": "BIF",
    "currencyCode": "BIF",
    "currencySymbol": "FBu",
    "deleted": false,
    "emoji": "🇧🇮",
    "emojiString": "U+1F1E7 U+1F1EE",
    "id": "183143ae-fcec-4369-a1ad-caed291816ff",
    "iso2": "BI",
    "iso3": "BDI",
    "locationTranslations": {
      "de": "Burundi",
      "en": "Burundi",
      "fr": "Burundi",
      "tr": "Burundi"
    },
    "name": "Burundi",
    "native": "Burundi",
    "phoneCode": "257",
    "region": "Africa",
    "subregion": "Eastern Africa",
    "updatedAt": 1657792795978
  },
  {
    "capital": "Thimphu",
    "createdAt": 1604406817996,
    "currency": "BTN",
    "currencyCode": "BTN",
    "currencySymbol": "Nu.",
    "deleted": false,
    "emoji": "🇧🇹",
    "emojiString": "U+1F1E7 U+1F1F9",
    "id": "dd555205-a47c-4ec1-bcf1-bc263ab70ab4",
    "iso2": "BT",
    "iso3": "BTN",
    "locationTranslations": {
      "de": "Bhutan",
      "en": "Bhutan",
      "fr": "Bhoutan",
      "tr": "Butan"
    },
    "name": "Bhutan",
    "native": "ʼbrug-yul",
    "phoneCode": "975",
    "region": "Asia",
    "subregion": "Southern Asia",
    "updatedAt": 1657792792663
  },
  {
    "capital": "George Town",
    "createdAt": 1604406817996,
    "currency": "KYD",
    "currencyCode": "KYD",
    "currencySymbol": "CI$",
    "deleted": false,
    "emoji": "🇰🇾",
    "emojiString": "U+1F1F0 U+1F1FE",
    "id": "3c9f2146-f750-419a-94a0-d654b69e40a4",
    "iso2": "KY",
    "iso3": "CYM",
    "locationTranslations": {
      "de": "Kaimaninseln",
      "en": "Cayman Islands",
      "fr": "Îles Caïmans",
      "tr": "Cayman Adaları"
    },
    "name": "Cayman Islands",
    "native": "Cayman Islands",
    "phoneCode": "+1-345",
    "region": "Americas",
    "subregion": "Caribbean",
    "updatedAt": 1658414429614
  },
  {
    "capital": "Gibraltar",
    "createdAt": 1604406817998,
    "currency": "GIP",
    "currencyCode": "GIP",
    "currencySymbol": "£",
    "deleted": false,
    "emoji": "🇬🇮",
    "emojiString": "U+1F1EC U+1F1EE",
    "id": "c598740d-a099-49b8-8290-ad81822cde2d",
    "iso2": "GI",
    "iso3": "GIB",
    "locationTranslations": {
      "de": "Gibraltar",
      "en": "Gibraltar",
      "fr": "Gibraltar",
      "tr": "Cebelitarık"
    },
    "name": "Gibraltar",
    "native": "Gibraltar",
    "phoneCode": "350",
    "region": "Europe",
    "subregion": "Southern Europe",
    "updatedAt": 1658414430903
  },
  {
    "capital": "Algiers",
    "createdAt": 1604406817996,
    "currency": "DZD",
    "currencyCode": "DZD",
    "currencySymbol": "DA",
    "deleted": false,
    "emoji": "🇩🇿",
    "emojiString": "U+1F1E9 U+1F1FF",
    "id": "6eba328f-a17f-43e1-88bd-a466efddac73",
    "iso2": "DZ",
    "iso3": "DZA",
    "locationTranslations": {
      "de": "Algerien",
      "en": "Algeria",
      "fr": "Algérie",
      "tr": "Cezayir"
    },
    "name": "Algeria",
    "native": "الجزائر",
    "phoneCode": "213",
    "region": "Africa",
    "subregion": "Northern Africa",
    "updatedAt": 1657792794171
  },
  {
    "capital": "Flying Fish Cove",
    "createdAt": 1604406817997,
    "currency": "AUD",
    "currencyCode": "AUD",
    "currencySymbol": "AU$",
    "deleted": false,
    "emoji": "🇨🇽",
    "emojiString": "U+1F1E8 U+1F1FD",
    "id": "052fb6b4-9832-4968-90a9-0f68f70d31f5",
    "iso2": "CX",
    "iso3": "CXR",
    "locationTranslations": {
      "de": "Weihnachtsinsel",
      "en": "Christmas Island",
      "fr": "Île Christmas",
      "tr": "Christmas Adası"
    },
    "name": "Christmas Island",
    "native": "Christmas Island",
    "phoneCode": "61",
    "region": "Oceania",
    "subregion": "Australia and New Zealand",
    "updatedAt": 1658414429849
  },
  {
    "capital": "Djibouti",
    "createdAt": 1604406817997,
    "currency": "DJF",
    "currencyCode": "DJF",
    "currencySymbol": "Fdj",
    "deleted": false,
    "emoji": "🇩🇯",
    "emojiString": "U+1F1E9 U+1F1EF",
    "id": "1ab42f52-d4ff-4318-94a3-f392e84aab23",
    "iso2": "DJ",
    "iso3": "DJI",
    "locationTranslations": {
      "de": "Dschibuti",
      "en": "Djibouti",
      "fr": "Djibouti",
      "tr": "Cibuti"
    },
    "name": "Djibouti",
    "native": "Djibouti",
    "phoneCode": "253",
    "region": "Africa",
    "subregion": "Eastern Africa",
    "updatedAt": 1657792794075
  },
  {
    "capital": "West Island",
    "createdAt": 1604406817997,
    "currency": "AUD",
    "currencyCode": "AUD",
    "currencySymbol": "AU$",
    "deleted": false,
    "emoji": "🇨🇨",
    "emojiString": "U+1F1E8 U+1F1E8",
    "id": "c9067e14-7fda-4ff1-ab90-51bead95b595",
    "iso2": "CC",
    "iso3": "CCK",
    "locationTranslations": {
      "de": "Kokosinseln",
      "en": "Cocos (Keeling) Islands",
      "fr": "Îles Cocos",
      "tr": "Cocos (Keeling) Adaları"
    },
    "name": "Cocos (Keeling) Islands",
    "native": "Cocos (Keeling) Islands",
    "phoneCode": "61",
    "region": "Oceania",
    "subregion": "Australia and New Zealand",
    "updatedAt": 1658414429787
  },
  {
    "capital": "Avarua",
    "createdAt": 1604406817997,
    "currency": "NZD",
    "currencyCode": "NZD",
    "currencySymbol": "NZ$",
    "deleted": false,
    "emoji": "🇨🇰",
    "emojiString": "U+1F1E8 U+1F1F0",
    "id": "5b467485-acdd-463b-a37b-fe6fcad6629f",
    "iso2": "CK",
    "iso3": "COK",
    "locationTranslations": {
      "de": "Cookinseln",
      "en": "Cook Islands",
      "fr": "Îles Cook",
      "tr": "Cook Adaları"
    },
    "name": "Cook Islands",
    "native": "Cook Islands",
    "phoneCode": "682",
    "region": "Oceania",
    "subregion": "Polynesia",
    "updatedAt": 1658414430026
  },
  {
    "capital": "Willemstad",
    "createdAt": 1604406817997,
    "currency": "ANG",
    "currencyCode": "ANG",
    "currencySymbol": "ƒ",
    "deleted": false,
    "emoji": "🇨🇼",
    "emojiString": "U+1F1E8 U+1F1FC",
    "id": "fe8705ab-e614-449f-a8e1-4ebcf00bfcb1",
    "iso2": "CW",
    "iso3": "CUW",
    "locationTranslations": {
      "de": "Curaçao",
      "en": "Curaçao",
      "fr": "Curaçao",
      "tr": "Curaçao"
    },
    "name": "Curaçao",
    "native": "Curaçao",
    "phoneCode": "599",
    "region": "Americas",
    "subregion": "Caribbean",
    "updatedAt": 1658414429556
  },
  {
    "capital": "N'Djamena",
    "createdAt": 1604406817997,
    "currency": "XAF",
    "currencyCode": "XAF",
    "currencySymbol": "Fr",
    "deleted": false,
    "emoji": "🇹🇩",
    "emojiString": "U+1F1F9 U+1F1E9",
    "id": "cb36f610-4578-4ed8-ab63-a560e91a4a45",
    "iso2": "TD",
    "iso3": "TCD",
    "locationTranslations": {
      "de": "Tschad",
      "en": "Chad",
      "fr": "Tchad",
      "tr": "Çad"
    },
    "name": "Chad",
    "native": "Tchad",
    "phoneCode": "235",
    "region": "Africa",
    "subregion": "Middle Africa",
    "updatedAt": 1657792796731
  },
  {
    "capital": "Prague",
    "createdAt": 1604406817997,
    "currency": "CZK",
    "currencyCode": "CZK",
    "currencySymbol": "Kč",
    "deleted": false,
    "emoji": "🇨🇿",
    "emojiString": "U+1F1E8 U+1F1FF",
    "id": "8e35432b-0362-4c72-ab02-4676c2575963",
    "iso2": "CZ",
    "iso3": "CZE",
    "locationTranslations": {
      "de": "Tschechien",
      "en": "Czech Republic",
      "fr": "République Tchèque",
      "tr": "Çek Cumhuriyeti"
    },
    "name": "Czech Republic",
    "native": "Česká republika",
    "phoneCode": "420",
    "region": "Europe",
    "subregion": "Eastern Europe",
    "updatedAt": 1657792793026
  },
  {
    "capital": "Beijing",
    "createdAt": 1604406817997,
    "currency": "CNY",
    "currencyCode": "CNY",
    "currencySymbol": "CN¥",
    "deleted": false,
    "emoji": "🇨🇳",
    "emojiString": "U+1F1E8 U+1F1F3",
    "id": "5000664e-6fbc-40b2-ba64-1325e2c524ee",
    "iso2": "CN",
    "iso3": "CHN",
    "locationTranslations": {
      "de": "Volksrepublik China",
      "en": "China",
      "fr": "Chine",
      "tr": "Çin"
    },
    "name": "China",
    "native": "中国",
    "phoneCode": "86",
    "region": "Asia",
    "subregion": "Eastern Asia",
    "updatedAt": 1657792794698
  },
  {
    "capital": "Copenhagen",
    "createdAt": 1604406817997,
    "currency": "DKK",
    "currencyCode": "DKK",
    "currencySymbol": "kr.",
    "deleted": false,
    "emoji": "🇩🇰",
    "emojiString": "U+1F1E9 U+1F1F0",
    "id": "faa87b1c-561b-4238-bbb4-ef1c2fca8c1d",
    "iso2": "DK",
    "iso3": "DNK",
    "locationTranslations": {
      "de": "Dänemark",
      "en": "Denmark",
      "fr": "Denmark",
      "tr": "Danimarka"
    },
    "name": "Denmark",
    "native": "Danmark",
    "phoneCode": "45",
    "region": "Europe",
    "subregion": "Northern Europe",
    "updatedAt": 1657792795231
  },
  {
    "capital": "Brazzaville",
    "createdAt": 1604406817997,
    "currency": "XAF",
    "currencyCode": "XAF",
    "currencySymbol": "Fr",
    "deleted": false,
    "emoji": "🇨🇬",
    "emojiString": "U+1F1E8 U+1F1EC",
    "id": "5ed4c6b1-c1e9-45e6-984e-1f8fe82f66c8",
    "iso2": "CG",
    "iso3": "COG",
    "locationTranslations": {
      "de": "Kongo, Republik",
      "en": "Congo",
      "fr": "Congo",
      "tr": "Demokratik Kongo Cumhuriyeti"
    },
    "name": "Congo",
    "native": "République du Congo",
    "phoneCode": "242",
    "region": "Africa",
    "subregion": "Middle Africa",
    "updatedAt": 1657792794343
  },
  {
    "capital": "Kinshasa",
    "createdAt": 1604406817997,
    "currency": "CDF",
    "currencyCode": "CDF",
    "currencySymbol": "FC",
    "deleted": false,
    "emoji": "🇨🇩",
    "emojiString": "U+1F1E8 U+1F1E9",
    "id": "67e8e7a0-3521-4e63-881c-2b92588276ac",
    "iso2": "CD",
    "iso3": "COD",
    "locationTranslations": {
      "de": "Kongo, Demokratische Republik",
      "en": "Democratic Republic of the Congo",
      "fr": "République Démocratique Du Congo",
      "tr": "Demokratik Kongo Cumhuriyeti"
    },
    "name": "Democratic Republic of the Congo",
    "native": "République démocratique du Congo",
    "phoneCode": "243",
    "region": "Africa",
    "subregion": "Middle Africa",
    "updatedAt": 1657792795427
  },
  {
    "capital": "Dili",
    "createdAt": 1604406817997,
    "currency": "USD",
    "currencyCode": "USD",
    "currencySymbol": "$",
    "deleted": false,
    "emoji": "🇹🇱",
    "emojiString": "U+1F1F9 U+1F1F1",
    "id": "ae1113ed-d950-430c-902c-db49177adb6e",
    "iso2": "TL",
    "iso3": "TLS",
    "locationTranslations": {
      "de": "Osttimor",
      "en": "East Timor",
      "fr": "Timor-Leste",
      "tr": "Doğu Timor"
    },
    "name": "East Timor",
    "native": "Timor-Leste",
    "phoneCode": "670",
    "region": "Asia",
    "subregion": "South-Eastern Asia",
    "updatedAt": 1657792792403
  },
  {
    "capital": "Santo Domingo",
    "createdAt": 1604406817997,
    "currency": "DOP",
    "currencyCode": "DOP",
    "currencySymbol": "RD$",
    "deleted": false,
    "emoji": "🇩🇴",
    "emojiString": "U+1F1E9 U+1F1F4",
    "id": "b0061f1b-fc8c-4ce1-b601-3648b9894ca9",
    "iso2": "DO",
    "iso3": "DOM",
    "locationTranslations": {
      "de": "Dominikanische Republik",
      "en": "Dominican Republic",
      "fr": "République Dominicaine",
      "tr": "Dominik Cumhuriyeti"
    },
    "name": "Dominican Republic",
    "native": "República Dominicana",
    "phoneCode": "+1-809 and 1-829",
    "region": "Americas",
    "subregion": "Caribbean",
    "updatedAt": 1657792794435
  },
  {
    "capital": "Roseau",
    "createdAt": 1604406817997,
    "currency": "XCD",
    "currencyCode": "XCD",
    "currencySymbol": "$",
    "deleted": false,
    "emoji": "🇩🇲",
    "emojiString": "U+1F1E9 U+1F1F2",
    "id": "5f7c7636-331f-4c18-b55c-d0dfcebe8050",
    "iso2": "DM",
    "iso3": "DMA",
    "locationTranslations": {
      "de": "Dominica",
      "en": "Dominica",
      "fr": "Dominique",
      "tr": "Dominika"
    },
    "name": "Dominica",
    "native": "Dominica",
    "phoneCode": "+1-767",
    "region": "Americas",
    "subregion": "Caribbean",
    "updatedAt": 1657792792185
  },
  {
    "capital": "Quito",
    "createdAt": 1604406817997,
    "currency": "USD",
    "currencyCode": "USD",
    "currencySymbol": "$",
    "deleted": false,
    "emoji": "🇪🇨",
    "emojiString": "U+1F1EA U+1F1E8",
    "id": "9ad4fbbd-0a31-4315-8617-d15a6c0b6773",
    "iso2": "EC",
    "iso3": "ECU",
    "locationTranslations": {
      "de": "Ecuador",
      "en": "Ecuador",
      "fr": "Équateur",
      "tr": "Ekvador"
    },
    "name": "Ecuador",
    "native": "Ecuador",
    "phoneCode": "593",
    "region": "Americas",
    "subregion": "South America",
    "updatedAt": 1657792800635
  },
  {
    "capital": "Malabo",
    "createdAt": 1604406817997,
    "currency": "XAF",
    "currencyCode": "XAF",
    "currencySymbol": "Fr",
    "deleted": false,
    "emoji": "🇬🇶",
    "emojiString": "U+1F1EC U+1F1F6",
    "id": "668b1e87-47fe-4b08-b648-68b47d604940",
    "iso2": "GQ",
    "iso3": "GNQ",
    "locationTranslations": {
      "de": "Äquatorialguinea",
      "en": "Equatorial Guinea",
      "fr": "Guinée Équatoriale",
      "tr": "Ekvator Ginesi"
    },
    "name": "Equatorial Guinea",
    "native": "Guinea Ecuatorial",
    "phoneCode": "240",
    "region": "Africa",
    "subregion": "Middle Africa",
    "updatedAt": 1657792803328
  },
  {
    "capital": "San Salvador",
    "createdAt": 1604406817997,
    "currency": "USD",
    "currencyCode": "USD",
    "currencySymbol": "$",
    "deleted": false,
    "emoji": "🇸🇻",
    "emojiString": "U+1F1F8 U+1F1FB",
    "id": "8fc4848f-03f0-4d56-a93f-6b413c8edfdd",
    "iso2": "SV",
    "iso3": "SLV",
    "locationTranslations": {
      "de": "El Salvador",
      "en": "El Salvador",
      "fr": "République Du Salvador",
      "tr": "El Salvador"
    },
    "name": "El Salvador",
    "native": "El Salvador",
    "phoneCode": "503",
    "region": "Americas",
    "subregion": "Central America",
    "updatedAt": 1657792806604
  },
  {
    "capital": "Jakarta",
    "createdAt": 1604406817998,
    "currency": "IDR",
    "currencyCode": "IDR",
    "currencySymbol": "Rp",
    "deleted": false,
    "emoji": "🇮🇩",
    "emojiString": "U+1F1EE U+1F1E9",
    "id": "f6f143cf-caad-4461-85fa-aa317f24948c",
    "iso2": "ID",
    "iso3": "IDN",
    "locationTranslations": {
      "de": "Indonesien",
      "en": "Indonesia",
      "fr": "Indonésie",
      "tr": "Endonezya"
    },
    "name": "Indonesia",
    "native": "Indonesia",
    "phoneCode": "62",
    "region": "Asia",
    "subregion": "South-Eastern Asia",
    "updatedAt": 1657792803226
  },
  {
    "capital": "Asmara",
    "createdAt": 1604406817997,
    "currency": "ERN",
    "currencyCode": "ERN",
    "currencySymbol": "Nkf",
    "deleted": false,
    "emoji": "🇪🇷",
    "emojiString": "U+1F1EA U+1F1F7",
    "id": "167204b4-02d3-4e71-9d86-09f822126154",
    "iso2": "ER",
    "iso3": "ERI",
    "locationTranslations": {
      "de": "Eritrea",
      "en": "Eritrea",
      "fr": "Érythrée",
      "tr": "Eritre"
    },
    "name": "Eritrea",
    "native": "ኤርትራ",
    "phoneCode": "291",
    "region": "Africa",
    "subregion": "Eastern Africa",
    "updatedAt": 1657792800731
  },
  {
    "capital": "Yerevan",
    "createdAt": 1604406817996,
    "currency": "AMD",
    "currencyCode": "AMD",
    "currencySymbol": "֏",
    "deleted": false,
    "emoji": "🇦🇲",
    "emojiString": "U+1F1E6 U+1F1F2",
    "id": "9666a9d5-a289-4e4a-8ffa-2f9e9663c039",
    "iso2": "AM",
    "iso3": "ARM",
    "locationTranslations": {
      "de": "Armenien",
      "en": "Armenia",
      "fr": "Arménie",
      "tr": "Ermenistan"
    },
    "name": "Armenia",
    "native": "Հայաստան",
    "phoneCode": "374",
    "region": "Asia",
    "subregion": "Western Asia",
    "updatedAt": 1657792794859
  },
  {
    "capital": "Tallinn",
    "createdAt": 1604406817997,
    "currency": "EUR",
    "currencyCode": "EUR",
    "currencySymbol": "€",
    "deleted": false,
    "emoji": "🇪🇪",
    "emojiString": "U+1F1EA U+1F1EA",
    "id": "7d6e2bbe-7e6e-4028-b206-e44cab253504",
    "iso2": "EE",
    "iso3": "EST",
    "locationTranslations": {
      "de": "Estland",
      "en": "Estonia",
      "fr": "Estonie",
      "tr": "Estonya"
    },
    "name": "Estonia",
    "native": "Eesti",
    "phoneCode": "372",
    "region": "Europe",
    "subregion": "Northern Europe",
    "updatedAt": 1657792801061
  },
  {
    "capital": "Addis Ababa",
    "createdAt": 1604406817997,
    "currency": "ETB",
    "currencyCode": "ETB",
    "currencySymbol": "Br",
    "deleted": false,
    "emoji": "🇪🇹",
    "emojiString": "U+1F1EA U+1F1F9",
    "id": "ea78332c-c141-404d-bfe3-3829efa30726",
    "iso2": "ET",
    "iso3": "ETH",
    "locationTranslations": {
      "de": "Äthiopien",
      "en": "Ethiopia",
      "fr": "Éthiopie",
      "tr": "Etiyopya"
    },
    "name": "Ethiopia",
    "native": "ኢትዮጵያ",
    "phoneCode": "251",
    "region": "Africa",
    "subregion": "Eastern Africa",
    "updatedAt": 1657792798008
  },
  {
    "capital": "Stanley",
    "createdAt": 1604406817997,
    "currency": "FKP",
    "currencyCode": "FKP",
    "currencySymbol": "FK£",
    "deleted": false,
    "emoji": "🇫🇰",
    "emojiString": "U+1F1EB U+1F1F0",
    "id": "21cbaa07-9f95-497f-8eb1-c1b545849e4d",
    "iso2": "FK",
    "iso3": "FLK",
    "locationTranslations": {
      "de": "Falklandinseln",
      "en": "Falkland Islands",
      "fr": "Îles Malouines",
      "tr": "Falkland Adaları"
    },
    "name": "Falkland Islands",
    "native": "Falkland Islands",
    "phoneCode": "500",
    "region": "Americas",
    "subregion": "South America",
    "updatedAt": 1658414431136
  },
  {
    "capital": "Torshavn",
    "createdAt": 1604406817997,
    "currency": "DKK",
    "currencyCode": "DKK",
    "currencySymbol": "kr.",
    "deleted": false,
    "emoji": "🇫🇴",
    "emojiString": "U+1F1EB U+1F1F4",
    "id": "16783566-8dd3-4dfa-ad50-5d1318fd1413",
    "iso2": "FO",
    "iso3": "FRO",
    "locationTranslations": {
      "de": "Färöer",
      "en": "Faroe Islands",
      "fr": "Îles Féroé",
      "tr": "Faroe Adaları"
    },
    "name": "Faroe Islands",
    "native": "Føroyar",
    "phoneCode": "298",
    "region": "Europe",
    "subregion": "Northern Europe",
    "updatedAt": 1658414430613
  },
  {
    "capital": "Rabat",
    "createdAt": 1604406817999,
    "currency": "MAD",
    "currencyCode": "MAD",
    "currencySymbol": "DH",
    "deleted": false,
    "emoji": "🇲🇦",
    "emojiString": "U+1F1F2 U+1F1E6",
    "id": "e51ce2c8-6210-4d8b-ae29-5553da7191ff",
    "iso2": "MA",
    "iso3": "MAR",
    "locationTranslations": {
      "de": "Marokko",
      "en": "Morocco",
      "fr": "Maroc",
      "tr": "Fas"
    },
    "name": "Morocco",
    "native": "المغرب",
    "phoneCode": "212",
    "region": "Africa",
    "subregion": "Northern Africa",
    "updatedAt": 1657792799745
  },
  {
    "capital": "Suva",
    "createdAt": 1604406817997,
    "currency": "FJD",
    "currencyCode": "FJD",
    "currencySymbol": "FJ$",
    "deleted": false,
    "emoji": "🇫🇯",
    "emojiString": "U+1F1EB U+1F1EF",
    "id": "b72e79ac-4fb9-4baf-80ef-b2b33d2152ec",
    "iso2": "FJ",
    "iso3": "FJI",
    "locationTranslations": {
      "de": "Fidschi",
      "en": "Fiji Islands",
      "fr": "Fidji",
      "tr": "Fiji Adaları"
    },
    "name": "Fiji Islands",
    "native": "Fiji",
    "phoneCode": "679",
    "region": "Oceania",
    "subregion": "Melanesia",
    "updatedAt": 1657792804750
  },
  {
    "capital": "Yamoussoukro",
    "createdAt": 1604406817997,
    "currency": "XOF",
    "currencyCode": "XOF",
    "currencySymbol": "₣",
    "deleted": false,
    "emoji": "🇨🇮",
    "emojiString": "U+1F1E8 U+1F1EE",
    "id": "a46247e7-3664-43e1-99ea-c53fa4d4877e",
    "iso2": "CI",
    "iso3": "CIV",
    "locationTranslations": {
      "de": "Elfenbeinküste",
      "en": "Cote D'Ivoire (Ivory Coast)",
      "fr": "Côte D'Ivoire",
      "tr": "Fildişi Sahili"
    },
    "name": "Cote D'Ivoire (Ivory Coast)",
    "native": null,
    "phoneCode": "225",
    "region": "Africa",
    "subregion": "Western Africa",
    "updatedAt": 1657792792933
  },
  {
    "capital": "Manila",
    "createdAt": 1604406818000,
    "currency": "PHP",
    "currencyCode": "PHP",
    "currencySymbol": "₱",
    "deleted": false,
    "emoji": "🇵🇭",
    "emojiString": "U+1F1F5 U+1F1ED",
    "id": "d699546f-c992-4ac4-a214-1df1b9cdbebb",
    "iso2": "PH",
    "iso3": "PHL",
    "locationTranslations": {
      "de": "Philippinen",
      "en": "Philippines",
      "fr": "Philippines",
      "tr": "Filipinler"
    },
    "name": "Philippines",
    "native": "Pilipinas",
    "phoneCode": "63",
    "region": "Asia",
    "subregion": "South-Eastern Asia",
    "updatedAt": 1657792804945
  },
  {
    "capital": "East Jerusalem",
    "createdAt": 1604406817999,
    "currency": "ILS",
    "currencyCode": "ILS",
    "currencySymbol": "₪",
    "deleted": false,
    "emoji": "🇵🇸",
    "emojiString": "U+1F1F5 U+1F1F8",
    "id": "66c12719-5428-480d-a57e-a650f44685bc",
    "iso2": "PS",
    "iso3": "PSE",
    "locationTranslations": {
      "de": "Palästinensische Autonomiegebiete",
      "en": "Palestinian Territory",
      "fr": "Territoires Palestiniens Occupés",
      "tr": "Filistin Toprakları"
    },
    "name": "Palestinian Territory",
    "native": "فلسطين",
    "phoneCode": "970",
    "region": "Asia",
    "subregion": "Western Asia",
    "updatedAt": 1658414430377
  },
  {
    "capital": "Helsinki",
    "createdAt": 1604406817997,
    "currency": "EUR",
    "currencyCode": "EUR",
    "currencySymbol": "€",
    "deleted": false,
    "emoji": "🇫🇮",
    "emojiString": "U+1F1EB U+1F1EE",
    "id": "e09506e6-c62c-4f80-b0e7-9335693dd3a0",
    "iso2": "FI",
    "iso3": "FIN",
    "locationTranslations": {
      "de": "Finnland",
      "en": "Finland",
      "fr": "Finlande",
      "tr": "Finlandiya"
    },
    "name": "Finland",
    "native": "Suomi",
    "phoneCode": "358",
    "region": "Europe",
    "subregion": "Northern Europe",
    "updatedAt": 1657792802422
  },
  {
    "capital": "Paris",
    "createdAt": 1604406817997,
    "currency": "EUR",
    "currencyCode": "EUR",
    "currencySymbol": "€",
    "deleted": false,
    "emoji": "🇫🇷",
    "emojiString": "U+1F1EB U+1F1F7",
    "id": "92b5ad7a-a93e-45d3-aae5-c8e58bd65130",
    "iso2": "FR",
    "iso3": "FRA",
    "locationTranslations": {
      "de": "Frankreich",
      "en": "France",
      "fr": "France",
      "tr": "Fransa"
    },
    "name": "France",
    "native": "France",
    "phoneCode": "33",
    "region": "Europe",
    "subregion": "Western Europe",
    "updatedAt": 1657792798720
  },
  {
    "capital": "Cayenne",
    "createdAt": 1604406817997,
    "currency": "EUR",
    "currencyCode": "EUR",
    "currencySymbol": "€",
    "deleted": false,
    "emoji": "🇬🇫",
    "emojiString": "U+1F1EC U+1F1EB",
    "id": "e9e2bf2b-e597-4b38-952e-fb228f4986a4",
    "iso2": "GF",
    "iso3": "GUF",
    "locationTranslations": {
      "de": "Französisch-Guayana",
      "en": "French Guiana",
      "fr": "Guyane",
      "tr": "Fransız Guyanası"
    },
    "name": "French Guiana",
    "native": "Guyane française",
    "phoneCode": "594",
    "region": "Americas",
    "subregion": "South America",
    "updatedAt": 1658414430729
  },
  {
    "capital": "Port-aux-Francais",
    "createdAt": 1604406817997,
    "currency": "EUR",
    "currencyCode": "EUR",
    "currencySymbol": "€",
    "deleted": false,
    "emoji": "🇹🇫",
    "emojiString": "U+1F1F9 U+1F1EB",
    "id": "ba27b4f5-e818-4b0a-bfaf-2e53426e4e5f",
    "iso2": "TF",
    "iso3": "ATF",
    "locationTranslations": {
      "de": "Französische Süd- und Antarktisgebiete",
      "en": "French Southern Territories",
      "fr": "Terres Australes Françaises",
      "tr": "Fransız Güney Toprakları"
    },
    "name": "French Southern Territories",
    "native": "Territoire des Terres australes et antarctiques fr",
    "phoneCode": "",
    "region": "Africa",
    "subregion": "Southern Africa",
    "updatedAt": 1658414432071
  },
  {
    "capital": "Papeete",
    "createdAt": 1604406817997,
    "currency": "XPF",
    "currencyCode": "XPF",
    "currencySymbol": "₣",
    "deleted": false,
    "emoji": "🇵🇫",
    "emojiString": "U+1F1F5 U+1F1EB",
    "id": "c20eb870-eeac-4da3-8be7-4e60ea7e4da0",
    "iso2": "PF",
    "iso3": "PYF",
    "locationTranslations": {
      "de": "Französisch-Polynesien",
      "en": "French Polynesia",
      "fr": "Polynésie Française",
      "tr": "Fransız Polinezyası"
    },
    "name": "French Polynesia",
    "native": "Polynésie française",
    "phoneCode": "689",
    "region": "Oceania",
    "subregion": "Polynesia",
    "updatedAt": 1658414431019
  },
  {
    "capital": "Libreville",
    "createdAt": 1604406817997,
    "currency": "XAF",
    "currencyCode": "XAF",
    "currencySymbol": "Fr",
    "deleted": false,
    "emoji": "🇬🇦",
    "emojiString": "U+1F1EC U+1F1E6",
    "id": "b47e249b-69dd-43c6-af71-25431ab029a2",
    "iso2": "GA",
    "iso3": "GAB",
    "locationTranslations": {
      "de": "Gabun",
      "en": "Gabon",
      "fr": "Gabon",
      "tr": "Gabon"
    },
    "name": "Gabon",
    "native": "Gabon",
    "phoneCode": "241",
    "region": "Africa",
    "subregion": "Middle Africa",
    "updatedAt": 1657792800102
  },
  {
    "capital": "Banjul",
    "createdAt": 1604406817997,
    "currency": "GMD",
    "currencyCode": "GMD",
    "currencySymbol": "D",
    "deleted": false,
    "emoji": "🇬🇲",
    "emojiString": "U+1F1EC U+1F1F2",
    "id": "7bedd65d-093d-4cd9-bcdf-3de871628f1d",
    "iso2": "GM",
    "iso3": "GMB",
    "locationTranslations": {
      "de": "Gambia",
      "en": "Gambia The",
      "fr": "Gambie",
      "tr": "Gambiya"
    },
    "name": "Gambia The",
    "native": "Gambia",
    "phoneCode": "220",
    "region": "Africa",
    "subregion": "Western Africa",
    "updatedAt": 1657792804304
  },
  {
    "capital": "Accra",
    "createdAt": 1604406817997,
    "currency": "GHS",
    "currencyCode": "GHS",
    "currencySymbol": "GH₵",
    "deleted": false,
    "emoji": "🇬🇭",
    "emojiString": "U+1F1EC U+1F1ED",
    "id": "5bfead96-2311-4828-ad12-1b6560c8b5ae",
    "iso2": "GH",
    "iso3": "GHA",
    "locationTranslations": {
      "de": "Ghana",
      "en": "Ghana",
      "fr": "Ghana",
      "tr": "Gana"
    },
    "name": "Ghana",
    "native": "Ghana",
    "phoneCode": "233",
    "region": "Africa",
    "subregion": "Western Africa",
    "updatedAt": 1657792808905
  },
  {
    "capital": "Conakry",
    "createdAt": 1604406817998,
    "currency": "GNF",
    "currencyCode": "GNF",
    "currencySymbol": "FG",
    "deleted": false,
    "emoji": "🇬🇳",
    "emojiString": "U+1F1EC U+1F1F3",
    "id": "e7a27a93-d454-4d7d-bebd-d9543776e112",
    "iso2": "GN",
    "iso3": "GIN",
    "locationTranslations": {
      "de": "Guinea",
      "en": "Guinea",
      "fr": "Guinée",
      "tr": "Gine"
    },
    "name": "Guinea",
    "native": "Guinée",
    "phoneCode": "224",
    "region": "Africa",
    "subregion": "Western Africa",
    "updatedAt": 1657792800549
  },
  {
    "capital": "Bissau",
    "createdAt": 1604406817998,
    "currency": "XOF",
    "currencyCode": "XOF",
    "currencySymbol": "₣",
    "deleted": false,
    "emoji": "🇬🇼",
    "emojiString": "U+1F1EC U+1F1FC",
    "id": "779a3f78-b981-4781-b790-88ec404397a2",
    "iso2": "GW",
    "iso3": "GNB",
    "locationTranslations": {
      "de": "Guinea-Bissau",
      "en": "Guinea-Bissau",
      "fr": "Guinée-Bissau",
      "tr": "Gine-Bissau"
    },
    "name": "Guinea-Bissau",
    "native": "Guiné-Bissau",
    "phoneCode": "245",
    "region": "Africa",
    "subregion": "Western Africa",
    "updatedAt": 1657792799651
  },
  {
    "capital": "St. George's",
    "createdAt": 1604406817998,
    "currency": "XCD",
    "currencyCode": "XCD",
    "currencySymbol": "$",
    "deleted": false,
    "emoji": "🇬🇩",
    "emojiString": "U+1F1EC U+1F1E9",
    "id": "60910e53-b6ad-4c97-be0d-f63cdc48c524",
    "iso2": "GD",
    "iso3": "GRD",
    "locationTranslations": {
      "de": "Grenada",
      "en": "Grenada",
      "fr": "Grenade",
      "tr": "Grenada"
    },
    "name": "Grenada",
    "native": "Grenada",
    "phoneCode": "+1-473",
    "region": "Americas",
    "subregion": "Caribbean",
    "updatedAt": 1657792807143
  },
  {
    "capital": "Nuuk",
    "createdAt": 1604406817998,
    "currency": "DKK",
    "currencyCode": "DKK",
    "currencySymbol": "kr.",
    "deleted": false,
    "emoji": "🇬🇱",
    "emojiString": "U+1F1EC U+1F1F1",
    "id": "8df9ada7-aa83-4270-af9a-154fa760576e",
    "iso2": "GL",
    "iso3": "GRL",
    "locationTranslations": {
      "de": "Grönland",
      "en": "Greenland",
      "fr": "Groenland",
      "tr": "Grönland"
    },
    "name": "Greenland",
    "native": "Kalaallit Nunaat",
    "phoneCode": "299",
    "region": "Americas",
    "subregion": "Northern America",
    "updatedAt": 1658414431251
  },
  {
    "capital": "Basse-Terre",
    "createdAt": 1604406817998,
    "currency": "EUR",
    "currencyCode": "EUR",
    "currencySymbol": "€",
    "deleted": false,
    "emoji": "🇬🇵",
    "emojiString": "U+1F1EC U+1F1F5",
    "id": "4351eb0c-5958-4dc5-ab71-808f6a3358f0",
    "iso2": "GP",
    "iso3": "GLP",
    "locationTranslations": {
      "de": "Guadeloupe",
      "en": "Guadeloupe",
      "fr": "Guadeloupe",
      "tr": "Guadeloupe"
    },
    "name": "Guadeloupe",
    "native": "Guadeloupe",
    "phoneCode": "590",
    "region": "Americas",
    "subregion": "Caribbean",
    "updatedAt": 1658414432595
  },
  {
    "capital": "Hagatna",
    "createdAt": 1604406817998,
    "currency": "USD",
    "currencyCode": "USD",
    "currencySymbol": "$",
    "deleted": false,
    "emoji": "🇬🇺",
    "emojiString": "U+1F1EC U+1F1FA",
    "id": "5e25627b-b6e8-4b11-a311-fa7d9c7d7372",
    "iso2": "GU",
    "iso3": "GUM",
    "locationTranslations": {
      "de": "Guam",
      "en": "Guam",
      "fr": "Guam",
      "tr": "Guam"
    },
    "name": "Guam",
    "native": "Guam",
    "phoneCode": "+1-671",
    "region": "Oceania",
    "subregion": "Micronesia",
    "updatedAt": 1658414430845
  },
  {
    "capital": "Guatemala City",
    "createdAt": 1604406817998,
    "currency": "GTQ",
    "currencyCode": "GTQ",
    "currencySymbol": "Q",
    "deleted": false,
    "emoji": "🇬🇹",
    "emojiString": "U+1F1EC U+1F1F9",
    "id": "3446b704-039b-4b7c-a828-91cca96e6023",
    "iso2": "GT",
    "iso3": "GTM",
    "locationTranslations": {
      "de": "Guatemala",
      "en": "Guatemala",
      "fr": "Guatemala",
      "tr": "Guatemala"
    },
    "name": "Guatemala",
    "native": "Guatemala",
    "phoneCode": "502",
    "region": "Americas",
    "subregion": "Central America",
    "updatedAt": 1657792801799
  },
  {
    "capital": "Georgetown",
    "createdAt": 1604406817998,
    "currency": "GYD",
    "currencyCode": "GYD",
    "currencySymbol": "G$",
    "deleted": false,
    "emoji": "🇬🇾",
    "emojiString": "U+1F1EC U+1F1FE",
    "id": "efa852f1-f564-427b-86ee-ccc04f42c87d",
    "iso2": "GY",
    "iso3": "GUY",
    "locationTranslations": {
      "de": "Guyana",
      "en": "Guyana",
      "fr": "Guyana",
      "tr": "Guyana"
    },
    "name": "Guyana",
    "native": "Guyana",
    "phoneCode": "592",
    "region": "Americas",
    "subregion": "South America",
    "updatedAt": 1657792801435
  },
  {
    "capital": "Pretoria",
    "createdAt": 1604406818001,
    "currency": "ZAR",
    "currencyCode": "ZAR",
    "currencySymbol": "R",
    "deleted": false,
    "emoji": "🇿🇦",
    "emojiString": "U+1F1FF U+1F1E6",
    "id": "ff212e8f-c73f-42e9-9332-cc0f7dd19f71",
    "iso2": "ZA",
    "iso3": "ZAF",
    "locationTranslations": {
      "de": "Südafrika",
      "en": "South Africa",
      "fr": "Afrique Du Sud",
      "tr": "Güney Afrika"
    },
    "name": "South Africa",
    "native": "South Africa",
    "phoneCode": "27",
    "region": "Africa",
    "subregion": "Southern Africa",
    "updatedAt": 1657792804113
  },
  {
    "capital": "Grytviken",
    "createdAt": 1604406818001,
    "currency": "GBP",
    "currencyCode": "GBP",
    "currencySymbol": "£",
    "deleted": false,
    "emoji": "🇬🇸",
    "emojiString": "U+1F1EC U+1F1F8",
    "id": "6730b11f-4c62-4ac9-94bf-524cd827ab1f",
    "iso2": "GS",
    "iso3": "SGS",
    "locationTranslations": {
      "de": "Südgeorgien und die Südlichen Sandwichinseln",
      "en": "South Georgia",
      "fr": "Géorgie Du Sud-Et-Les Îles Sandwich Du Sud",
      "tr": "Güney Georgia"
    },
    "name": "South Georgia",
    "native": "South Georgia",
    "phoneCode": "",
    "region": "Americas",
    "subregion": "South America",
    "updatedAt": 1658414431604
  },
  {
    "capital": "Seoul",
    "createdAt": 1604406817998,
    "currency": "KRW",
    "currencyCode": "KRW",
    "currencySymbol": "₩",
    "deleted": false,
    "emoji": "🇰🇷",
    "emojiString": "U+1F1F0 U+1F1F7",
    "id": "663d0e98-868e-4ce7-9408-d6b23e66f88c",
    "iso2": "KR",
    "iso3": "KOR",
    "locationTranslations": {
      "de": "Korea, Süd",
      "en": "Korea South",
      "fr": "République De Corée",
      "tr": "Güney Kore"
    },
    "name": "Korea South",
    "native": "대한민국",
    "phoneCode": "82",
    "region": "Asia",
    "subregion": "Eastern Asia",
    "updatedAt": 1657792797135
  },
  {
    "capital": "Juba",
    "createdAt": 1604406818001,
    "currency": "SSP",
    "currencyCode": "SSP",
    "currencySymbol": "SS£",
    "deleted": false,
    "emoji": "🇸🇸",
    "emojiString": "U+1F1F8 U+1F1F8",
    "id": "24730e49-8593-4038-a1e7-6faa8d01c581",
    "iso2": "SS",
    "iso3": "SSD",
    "locationTranslations": {
      "de": "Südsudan",
      "en": "South Sudan",
      "fr": "Soudan Du Sud",
      "tr": "Güney Sudan"
    },
    "name": "South Sudan",
    "native": "South Sudan",
    "phoneCode": "211",
    "region": "Africa",
    "subregion": "Middle Africa",
    "updatedAt": 1657792807952
  },
  {
    "capital": "Tbilisi",
    "createdAt": 1604406817997,
    "currency": "GEL",
    "currencyCode": "GEL",
    "currencySymbol": "₾",
    "deleted": false,
    "emoji": "🇬🇪",
    "emojiString": "U+1F1EC U+1F1EA",
    "id": "d162b640-76a5-4f85-87d8-8df54777aee3",
    "iso2": "GE",
    "iso3": "GEO",
    "locationTranslations": {
      "de": "Georgien",
      "en": "Georgia",
      "fr": "Géorgie",
      "tr": "Gürcistan"
    },
    "name": "Georgia",
    "native": "საქართველო",
    "phoneCode": "995",
    "region": "Asia",
    "subregion": "Western Asia",
    "updatedAt": 1657792801338
  },
  {
    "capital": "Port-au-Prince",
    "createdAt": 1604406817998,
    "currency": "HTG",
    "currencyCode": "HTG",
    "currencySymbol": "G",
    "deleted": false,
    "emoji": "🇭🇹",
    "emojiString": "U+1F1ED U+1F1F9",
    "id": "0adf3a42-bc3f-4cce-af44-01cdc4c78713",
    "iso2": "HT",
    "iso3": "HTI",
    "locationTranslations": {
      "de": "Haiti",
      "en": "Haiti",
      "fr": "Haïti",
      "tr": "Haiti"
    },
    "name": "Haiti",
    "native": "Haïti",
    "phoneCode": "509",
    "region": "Americas",
    "subregion": "Caribbean",
    "updatedAt": 1657792803486
  },
  {
    "capital": "",
    "createdAt": 1604406817998,
    "currency": "AUD",
    "currencyCode": "AUD",
    "currencySymbol": "AU$",
    "deleted": false,
    "emoji": "🇭🇲",
    "emojiString": "U+1F1ED U+1F1F2",
    "id": "9b15235e-f8e0-4dfe-968d-4b7f2fa1f5a4",
    "iso2": "HM",
    "iso3": "HMD",
    "locationTranslations": {
      "de": "Heard- und McDonald-Inseln",
      "en": "Heard and McDonald Islands",
      "fr": "Îles Heard-Et-MacDonald",
      "tr": "Heard Adası ve McDonald Adaları"
    },
    "name": "Heard and McDonald Islands",
    "native": "Heard Island and McDonald Islands",
    "phoneCode": " ",
    "region": "Other",
    "subregion": "",
    "updatedAt": 1658414432196
  },
  {
    "capital": "Zagreb",
    "createdAt": 1604406817997,
    "currency": "HRK",
    "currencyCode": "HRK",
    "currencySymbol": "kn",
    "deleted": false,
    "emoji": "🇭🇷",
    "emojiString": "U+1F1ED U+1F1F7",
    "id": "d296a90d-4712-4708-be74-1938b3377ce6",
    "iso2": "HR",
    "iso3": "HRV",
    "locationTranslations": {
      "de": "Kroatien",
      "en": "Croatia",
      "fr": "Croatie",
      "tr": "Hırvatistan"
    },
    "name": "Croatia",
    "native": "Hrvatska",
    "phoneCode": "385",
    "region": "Europe",
    "subregion": "Southern Europe",
    "updatedAt": 1657792792831
  },
  {
    "capital": "New Delhi",
    "createdAt": 1604406817998,
    "currency": "INR",
    "currencyCode": "INR",
    "currencySymbol": "Rs.",
    "deleted": false,
    "emoji": "🇮🇳",
    "emojiString": "U+1F1EE U+1F1F3",
    "id": "b231ee16-7409-4cfb-8197-9fe4802d2e9e",
    "iso2": "IN",
    "iso3": "IND",
    "locationTranslations": {
      "de": "Indien",
      "en": "India",
      "fr": "Inde",
      "tr": "Hindistan"
    },
    "name": "India",
    "native": "भारत",
    "phoneCode": "91",
    "region": "Asia",
    "subregion": "Southern Asia",
    "updatedAt": 1657792802694
  },
  {
    "capital": "Amsterdam",
    "createdAt": 1604406817999,
    "currency": "EUR",
    "currencyCode": "EUR",
    "currencySymbol": "€",
    "deleted": false,
    "emoji": "🇳🇱",
    "emojiString": "U+1F1F3 U+1F1F1",
    "id": "1482396d-3cc1-4ed1-b649-88b462c13fed",
    "iso2": "NL",
    "iso3": "NLD",
    "locationTranslations": {
      "de": "Niederlande",
      "en": "Netherlands",
      "fr": "Pays-Bas",
      "tr": "Hollanda"
    },
    "name": "Netherlands",
    "native": "Nederland",
    "phoneCode": "31",
    "region": "Europe",
    "subregion": "Western Europe",
    "updatedAt": 1657792798543
  },
  {
    "capital": "",
    "createdAt": 1604406817999,
    "currency": "",
    "currencyCode": "",
    "currencySymbol": "",
    "deleted": false,
    "emoji": null,
    "emojiString": null,
    "id": "4be7bb1c-58b3-4ae2-8cc7-b3a6f9be6a40",
    "iso2": "AN",
    "iso3": "ANT",
    "locationTranslations": {
      "de": "Niederländische Antillen",
      "en": "Netherlands Antilles",
      "fr": null,
      "tr": "Hollanda Antilleri"
    },
    "name": "Netherlands Antilles",
    "native": null,
    "phoneCode": "",
    "region": "Americas",
    "subregion": null,
    "updatedAt": 1658414432364
  },
  {
    "capital": "Tegucigalpa",
    "createdAt": 1604406817998,
    "currency": "HNL",
    "currencyCode": "HNL",
    "currencySymbol": "L",
    "deleted": false,
    "emoji": "🇭🇳",
    "emojiString": "U+1F1ED U+1F1F3",
    "id": "7e86daa8-394f-486b-a429-354a88795e0a",
    "iso2": "HN",
    "iso3": "HND",
    "locationTranslations": {
      "de": "Honduras",
      "en": "Honduras",
      "fr": "Honduras",
      "tr": "Honduras"
    },
    "name": "Honduras",
    "native": "Honduras",
    "phoneCode": "504",
    "region": "Americas",
    "subregion": "Central America",
    "updatedAt": 1657792800276
  },
  {
    "capital": "Hong Kong",
    "createdAt": 1604406817998,
    "currency": "HKD",
    "currencyCode": "HKD",
    "currencySymbol": "HK$",
    "deleted": false,
    "emoji": "🇭🇰",
    "emojiString": "U+1F1ED U+1F1F0",
    "id": "02c1664e-7b28-464a-bd06-26adb846d8ac",
    "iso2": "HK",
    "iso3": "HKG",
    "locationTranslations": {
      "de": "Hongkong",
      "en": "Hong Kong S.A.R.",
      "fr": "Hong Kong",
      "tr": "Hong Kong"
    },
    "name": "Hong Kong S.A.R.",
    "native": "香港",
    "phoneCode": "852",
    "region": "Asia",
    "subregion": "Eastern Asia",
    "updatedAt": 1658414432253
  },
  {
    "capital": "Baghdad",
    "createdAt": 1604406817998,
    "currency": "IQD",
    "currencyCode": "IQD",
    "currencySymbol": "د.ع.",
    "deleted": false,
    "emoji": "🇮🇶",
    "emojiString": "U+1F1EE U+1F1F6",
    "id": "8c90478b-8bd0-4b63-b10d-728c3e9d36fb",
    "iso2": "IQ",
    "iso3": "IRQ",
    "locationTranslations": {
      "de": "Irak",
      "en": "Iraq",
      "fr": "Irak",
      "tr": "Irak"
    },
    "name": "Iraq",
    "native": "العراق",
    "phoneCode": "964",
    "region": "Asia",
    "subregion": "Western Asia",
    "updatedAt": 1657792797575
  },
  {
    "capital": "Tehran",
    "createdAt": 1604406817998,
    "currency": "IRR",
    "currencyCode": "IRR",
    "currencySymbol": "﷼",
    "deleted": false,
    "emoji": "🇮🇷",
    "emojiString": "U+1F1EE U+1F1F7",
    "id": "3f4a1ef1-8768-4d4e-957d-29e06a3e7fe6",
    "iso2": "IR",
    "iso3": "IRN",
    "locationTranslations": {
      "de": "Iran",
      "en": "Iran",
      "fr": "République Islamique D'Iran",
      "tr": "İran"
    },
    "name": "Iran",
    "native": "ایران",
    "phoneCode": "98",
    "region": "Asia",
    "subregion": "Southern Asia",
    "updatedAt": 1657792800370
  },
  {
    "capital": "Dublin",
    "createdAt": 1604406817998,
    "currency": "EUR",
    "currencyCode": "EUR",
    "currencySymbol": "€",
    "deleted": false,
    "emoji": "🇮🇪",
    "emojiString": "U+1F1EE U+1F1EA",
    "id": "e20c070f-1901-407e-9397-0ce61fcd2ec3",
    "iso2": "IE",
    "iso3": "IRL",
    "locationTranslations": {
      "de": "Irland",
      "en": "Ireland",
      "fr": "Irlande",
      "tr": "İrlanda"
    },
    "name": "Ireland",
    "native": "Éire",
    "phoneCode": "353",
    "region": "Europe",
    "subregion": "Northern Europe",
    "updatedAt": 1657792808324
  },
  {
    "capital": "Madrid",
    "createdAt": 1604406818001,
    "currency": "EUR",
    "currencyCode": "EUR",
    "currencySymbol": "€",
    "deleted": false,
    "emoji": "🇪🇸",
    "emojiString": "U+1F1EA U+1F1F8",
    "id": "a99422d3-118d-4120-9477-d37cfdaef91c",
    "iso2": "ES",
    "iso3": "ESP",
    "locationTranslations": {
      "de": "Spanien",
      "en": "Spain",
      "fr": "Espagne",
      "tr": "İspanya"
    },
    "name": "Spain",
    "native": "España",
    "phoneCode": "34",
    "region": "Europe",
    "subregion": "Southern Europe",
    "updatedAt": 1657792805312
  },
  {
    "capital": "Jerusalem",
    "createdAt": 1604406817998,
    "currency": "ILS",
    "currencyCode": "ILS",
    "currencySymbol": "₪",
    "deleted": false,
    "emoji": "🇮🇱",
    "emojiString": "U+1F1EE U+1F1F1",
    "id": "2f8c5935-6ba5-4b44-9c4d-67b0135af70b",
    "iso2": "IL",
    "iso3": "ISR",
    "locationTranslations": {
      "de": "Israel",
      "en": "Israel",
      "fr": "Israël",
      "tr": "İsrail"
    },
    "name": "Israel",
    "native": "יִשְׂרָאֵל",
    "phoneCode": "972",
    "region": "Asia",
    "subregion": "Western Asia",
    "updatedAt": 1657792801710
  },
  {
    "capital": "Stockholm",
    "createdAt": 1604406818001,
    "currency": "SEK",
    "currencyCode": "SEK",
    "currencySymbol": "kr",
    "deleted": false,
    "emoji": "🇸🇪",
    "emojiString": "U+1F1F8 U+1F1EA",
    "id": "ed7dd6db-f662-4cc4-94d8-518d9d453050",
    "iso2": "SE",
    "iso3": "SWE",
    "locationTranslations": {
      "de": "Schweden",
      "en": "Sweden",
      "fr": "Suède",
      "tr": "İsveç"
    },
    "name": "Sweden",
    "native": "Sverige",
    "phoneCode": "46",
    "region": "Europe",
    "subregion": "Northern Europe",
    "updatedAt": 1657792808056
  },
  {
    "capital": "Berne",
    "createdAt": 1604406818001,
    "currency": "CHF",
    "currencyCode": "CHF",
    "currencySymbol": "CHF",
    "deleted": false,
    "emoji": "🇨🇭",
    "emojiString": "U+1F1E8 U+1F1ED",
    "id": "792c39d3-0267-4ae3-90d8-7d5ba22cdafb",
    "iso2": "CH",
    "iso3": "CHE",
    "locationTranslations": {
      "de": "Schweiz",
      "en": "Switzerland",
      "fr": "Suisse",
      "tr": "İsviçre"
    },
    "name": "Switzerland",
    "native": "Schweiz",
    "phoneCode": "41",
    "region": "Europe",
    "subregion": "Western Europe",
    "updatedAt": 1657792805022
  },
  {
    "capital": "Rome",
    "createdAt": 1604406817998,
    "currency": "EUR",
    "currencyCode": "EUR",
    "currencySymbol": "€",
    "deleted": false,
    "emoji": "🇮🇹",
    "emojiString": "U+1F1EE U+1F1F9",
    "id": "81e20ad9-fb47-4385-8846-93fdebfdb0ae",
    "iso2": "IT",
    "iso3": "ITA",
    "locationTranslations": {
      "de": "Italien",
      "en": "Italy",
      "fr": "Italie",
      "tr": "İtalya"
    },
    "name": "Italy",
    "native": "Italia",
    "phoneCode": "39",
    "region": "Europe",
    "subregion": "Southern Europe",
    "updatedAt": 1657792798276
  },
  {
    "capital": "Reykjavik",
    "createdAt": 1604406817998,
    "currency": "ISK",
    "currencyCode": "ISK",
    "currencySymbol": "kr",
    "deleted": false,
    "emoji": "🇮🇸",
    "emojiString": "U+1F1EE U+1F1F8",
    "id": "00154b5d-6536-40d3-b195-e3e989b41884",
    "iso2": "IS",
    "iso3": "ISL",
    "locationTranslations": {
      "de": "Island",
      "en": "Iceland",
      "fr": "Islande",
      "tr": "İzlanda"
    },
    "name": "Iceland",
    "native": "Ísland",
    "phoneCode": "354",
    "region": "Europe",
    "subregion": "Northern Europe",
    "updatedAt": 1657792803407
  },
  {
    "capital": "Kingston",
    "createdAt": 1604406817998,
    "currency": "JMD",
    "currencyCode": "JMD",
    "currencySymbol": "J$",
    "deleted": false,
    "emoji": "🇯🇲",
    "emojiString": "U+1F1EF U+1F1F2",
    "id": "ed9d6006-0ba1-401a-ae7e-dbd2ac94ae18",
    "iso2": "JM",
    "iso3": "JAM",
    "locationTranslations": {
      "de": "Jamaika",
      "en": "Jamaica",
      "fr": "Jamaïque",
      "tr": "Jamaika"
    },
    "name": "Jamaica",
    "native": "Jamaica",
    "phoneCode": "+1-876",
    "region": "Americas",
    "subregion": "Caribbean",
    "updatedAt": 1657792808744
  },
  {
    "capital": "Tokyo",
    "createdAt": 1604406817998,
    "currency": "JPY",
    "currencyCode": "JPY",
    "currencySymbol": "¥",
    "deleted": false,
    "emoji": "🇯🇵",
    "emojiString": "U+1F1EF U+1F1F5",
    "id": "8abc0cff-10a6-413c-bdac-56c84e4a07c2",
    "iso2": "JP",
    "iso3": "JPN",
    "locationTranslations": {
      "de": "Japan",
      "en": "Japan",
      "fr": "Japon",
      "tr": "Japonya"
    },
    "name": "Japan",
    "native": "日本",
    "phoneCode": "81",
    "region": "Asia",
    "subregion": "Eastern Asia",
    "updatedAt": 1657792799009
  },
  {
    "capital": "Saint Helier",
    "createdAt": 1604406817998,
    "currency": "GBP",
    "currencyCode": "GBP",
    "currencySymbol": "£",
    "deleted": false,
    "emoji": "🇯🇪",
    "emojiString": "U+1F1EF U+1F1EA",
    "id": "e706fc9b-1cf2-4935-9b12-31e6e23b4d94",
    "iso2": "JE",
    "iso3": "JEY",
    "locationTranslations": {
      "de": "Jersey",
      "en": "Jersey",
      "fr": "Jersey",
      "tr": "Jersey"
    },
    "name": "Jersey",
    "native": "Jersey",
    "phoneCode": "+44-1534",
    "region": "Europe",
    "subregion": "Northern Europe",
    "updatedAt": 1658414431955
  },
  {
    "capital": "Phnom Penh",
    "createdAt": 1604406817996,
    "currency": "KHR",
    "currencyCode": "KHR",
    "currencySymbol": "៛",
    "deleted": false,
    "emoji": "🇰🇭",
    "emojiString": "U+1F1F0 U+1F1ED",
    "id": "256e5b68-150b-42e5-8751-9f917c1ae899",
    "iso2": "KH",
    "iso3": "KHM",
    "locationTranslations": {
      "de": "Kambodscha",
      "en": "Cambodia",
      "fr": "Cambodge",
      "tr": "Kamboçya"
    },
    "name": "Cambodia",
    "native": "Kâmpŭchéa",
    "phoneCode": "855",
    "region": "Asia",
    "subregion": "South-Eastern Asia",
    "updatedAt": 1657792793983
  },
  {
    "capital": "Yaounde",
    "createdAt": 1604406817996,
    "currency": "XAF",
    "currencyCode": "XAF",
    "currencySymbol": "Fr",
    "deleted": false,
    "emoji": "🇨🇲",
    "emojiString": "U+1F1E8 U+1F1F2",
    "id": "111be3f5-3ab4-40c7-a39f-d7dbfe900687",
    "iso2": "CM",
    "iso3": "CMR",
    "locationTranslations": {
      "de": "Kamerun",
      "en": "Cameroon",
      "fr": "Cameroun",
      "tr": "Kamerun"
    },
    "name": "Cameroon",
    "native": "Cameroon",
    "phoneCode": "237",
    "region": "Africa",
    "subregion": "Middle Africa",
    "updatedAt": 1657792796133
  },
  {
    "capital": "Ottawa",
    "createdAt": 1604406817996,
    "currency": "CAD",
    "currencyCode": "CAD",
    "currencySymbol": "CA$",
    "deleted": false,
    "emoji": "🇨🇦",
    "emojiString": "U+1F1E8 U+1F1E6",
    "id": "39c51f9f-f1a6-40d2-a881-167070634cf5",
    "iso2": "CA",
    "iso3": "CAN",
    "locationTranslations": {
      "de": "Kanada",
      "en": "Canada",
      "fr": "Canada",
      "tr": "Kanada"
    },
    "name": "Canada",
    "native": "Canada",
    "phoneCode": "1",
    "region": "Americas",
    "subregion": "Northern America",
    "updatedAt": 1657792796301
  },
  {
    "capital": "Podgorica",
    "createdAt": 1604406817999,
    "currency": "EUR",
    "currencyCode": "EUR",
    "currencySymbol": "€",
    "deleted": false,
    "emoji": "🇲🇪",
    "emojiString": "U+1F1F2 U+1F1EA",
    "id": "5e46f73d-0acd-4860-8ccd-6321a81d87a0",
    "iso2": "ME",
    "iso3": "MNE",
    "locationTranslations": {
      "de": "Montenegro",
      "en": "Montenegro",
      "fr": "Monténégro",
      "tr": "Karadağ"
    },
    "name": "Montenegro",
    "native": "Црна Гора",
    "phoneCode": "382",
    "region": "Europe",
    "subregion": "Southern Europe",
    "updatedAt": 1657792806515
  },
  {
    "capital": "Doha",
    "createdAt": 1604406818000,
    "currency": "QAR",
    "currencyCode": "QAR",
    "currencySymbol": "QR",
    "deleted": false,
    "emoji": "🇶🇦",
    "emojiString": "U+1F1F6 U+1F1E6",
    "id": "49ff14b6-0894-42c1-9a6c-dbd0314d576c",
    "iso2": "QA",
    "iso3": "QAT",
    "locationTranslations": {
      "de": "Katar",
      "en": "Qatar",
      "fr": "Qatar",
      "tr": "Katar"
    },
    "name": "Qatar",
    "native": "قطر",
    "phoneCode": "974",
    "region": "Asia",
    "subregion": "Western Asia",
    "updatedAt": 1657792796976
  },
  {
    "capital": "Astana",
    "createdAt": 1604406817998,
    "currency": "KZT",
    "currencyCode": "KZT",
    "currencySymbol": "₸",
    "deleted": false,
    "emoji": "🇰🇿",
    "emojiString": "U+1F1F0 U+1F1FF",
    "id": "da1c4f8f-2ee0-46cb-bc2b-960ea8c3b237",
    "iso2": "KZ",
    "iso3": "KAZ",
    "locationTranslations": {
      "de": "Kasachstan",
      "en": "Kazakhstan",
      "fr": "Kazakhstan",
      "tr": "Kazakistan"
    },
    "name": "Kazakhstan",
    "native": "Қазақстан",
    "phoneCode": "7",
    "region": "Asia",
    "subregion": "Central Asia",
    "updatedAt": 1657792797914
  },
  {
    "capital": "Nairobi",
    "createdAt": 1604406817998,
    "currency": "KES",
    "currencyCode": "KES",
    "currencySymbol": "KSh",
    "deleted": false,
    "emoji": "🇰🇪",
    "emojiString": "U+1F1F0 U+1F1EA",
    "id": "24b65d2f-6054-40e7-b4f4-b35ee2455a2c",
    "iso2": "KE",
    "iso3": "KEN",
    "locationTranslations": {
      "de": "Kenia",
      "en": "Kenya",
      "fr": "Kenya",
      "tr": "Kenya"
    },
    "name": "Kenya",
    "native": "Kenya",
    "phoneCode": "254",
    "region": "Africa",
    "subregion": "Eastern Africa",
    "updatedAt": 1657792800188
  },
  {
    "capital": "Nicosia",
    "createdAt": 1604406817997,
    "currency": "EUR",
    "currencyCode": "EUR",
    "currencySymbol": "€",
    "deleted": false,
    "emoji": "🇨🇾",
    "emojiString": "U+1F1E8 U+1F1FE",
    "id": "69cb8389-cd02-4e40-a710-39559587766b",
    "iso2": "CY",
    "iso3": "CYP",
    "locationTranslations": {
      "de": "Zypern",
      "en": "Cyprus",
      "fr": "Chypre",
      "tr": "Kıbrıs"
    },
    "name": "Cyprus",
    "native": "Κύπρος",
    "phoneCode": "357",
    "region": "Europe",
    "subregion": "Southern Europe",
    "updatedAt": 1657792793112
  },
  {
    "capital": "Bishkek",
    "createdAt": 1604406817998,
    "currency": "KGS",
    "currencyCode": "KGS",
    "currencySymbol": "с",
    "deleted": false,
    "emoji": "🇰🇬",
    "emojiString": "U+1F1F0 U+1F1EC",
    "id": "c7ae295e-db6d-44c4-8587-d150adb356b2",
    "iso2": "KG",
    "iso3": "KGZ",
    "locationTranslations": {
      "de": "Kirgisistan",
      "en": "Kyrgyzstan",
      "fr": "Kirghizistan",
      "tr": "Kırgızistan"
    },
    "name": "Kyrgyzstan",
    "native": "Кыргызстан",
    "phoneCode": "996",
    "region": "Asia",
    "subregion": "Central Asia",
    "updatedAt": 1657792797660
  },
  {
    "capital": "Tarawa",
    "createdAt": 1604406817998,
    "currency": "AUD",
    "currencyCode": "AUD",
    "currencySymbol": "AU$",
    "deleted": false,
    "emoji": "🇰🇮",
    "emojiString": "U+1F1F0 U+1F1EE",
    "id": "ca31a99c-5469-4829-a07d-8db2d43c4f9e",
    "iso2": "KI",
    "iso3": "KIR",
    "locationTranslations": {
      "de": "Kiribati",
      "en": "Kiribati",
      "fr": "Kiribati",
      "tr": "Kiribati"
    },
    "name": "Kiribati",
    "native": "Kiribati",
    "phoneCode": "686",
    "region": "Oceania",
    "subregion": "Micronesia",
    "updatedAt": 1657792799554
  },
  {
    "capital": "Lefkoşa",
    "createdAt": 1604406817997,
    "currency": "EUR",
    "currencyCode": "EUR",
    "currencySymbol": "€",
    "deleted": false,
    "emoji": "🇨🇾",
    "emojiString": "U+1F1E8 U+1F1FE",
    "id": "3941584b-138a-4969-bf10-d66a18a3222d",
    "iso2": "KK",
    "iso3": "KTC",
    "locationTranslations": {
      "de": null,
      "en": "Northern Cyprus",
      "fr": "Chypre du Nord",
      "tr": "KKTC"
    },
    "name": "KKTC",
    "native": "KKTC",
    "phoneCode": "+90-392",
    "region": "Europe",
    "subregion": "Southern Europe",
    "updatedAt": 1625813552924
  },
  {
    "capital": "Bogota",
    "createdAt": 1604406817997,
    "currency": "COP",
    "currencyCode": "COP",
    "currencySymbol": "CO$",
    "deleted": false,
    "emoji": "🇨🇴",
    "emojiString": "U+1F1E8 U+1F1F4",
    "id": "d8eeb7f6-a87c-4803-9b6c-1b90cefb4933",
    "iso2": "CO",
    "iso3": "COL",
    "locationTranslations": {
      "de": "Kolumbien",
      "en": "Colombia",
      "fr": "Colombie",
      "tr": "Kolombiya"
    },
    "name": "Colombia",
    "native": "Colombia",
    "phoneCode": "57",
    "region": "Americas",
    "subregion": "South America",
    "updatedAt": 1657792793727
  },
  {
    "capital": "Moroni",
    "createdAt": 1604406817997,
    "currency": "KMF",
    "currencyCode": "KMF",
    "currencySymbol": "CF",
    "deleted": false,
    "emoji": "🇰🇲",
    "emojiString": "U+1F1F0 U+1F1F2",
    "id": "683407f1-53df-4315-8d18-695e4a516ca3",
    "iso2": "KM",
    "iso3": "COM",
    "locationTranslations": {
      "de": "Komoren",
      "en": "Comoros",
      "fr": "Comores",
      "tr": "Komorlar"
    },
    "name": "Comoros",
    "native": "Komori",
    "phoneCode": "269",
    "region": "Africa",
    "subregion": "Eastern Africa",
    "updatedAt": 1657792795709
  },
  {
    "capital": "Pristina",
    "createdAt": 1604406817998,
    "currency": "EUR",
    "currencyCode": "EUR",
    "currencySymbol": "€",
    "deleted": false,
    "emoji": "🇽🇰",
    "emojiString": "U+1F1FD U+1F1F0",
    "id": "9c1dbc30-e868-42c5-9e30-3b91593e7e13",
    "iso2": "XK",
    "iso3": "XKX",
    "locationTranslations": {
      "de": "Kosovo",
      "en": "Kosovo",
      "fr": "Kosovo",
      "tr": "Kosova"
    },
    "name": "Kosovo",
    "native": "Republika e Kosovës",
    "phoneCode": "383",
    "region": "Europe",
    "subregion": "Eastern Europe",
    "updatedAt": 1658414431487
  },
  {
    "capital": "San Jose",
    "createdAt": 1604406817997,
    "currency": "CRC",
    "currencyCode": "CRC",
    "currencySymbol": "₡",
    "deleted": false,
    "emoji": "🇨🇷",
    "emojiString": "U+1F1E8 U+1F1F7",
    "id": "f037fdf6-13ce-4a18-ac8e-1807120d1df2",
    "iso2": "CR",
    "iso3": "CRI",
    "locationTranslations": {
      "de": "Costa Rica",
      "en": "Costa Rica",
      "fr": "Costa Rica",
      "tr": "Kosta Rika"
    },
    "name": "Costa Rica",
    "native": "Costa Rica",
    "phoneCode": "506",
    "region": "Americas",
    "subregion": "Central America",
    "updatedAt": 1657792793548
  },
  {
    "capital": "Kuwait City",
    "createdAt": 1604406817998,
    "currency": "KWD",
    "currencyCode": "KWD",
    "currencySymbol": "KD",
    "deleted": false,
    "emoji": "🇰🇼",
    "emojiString": "U+1F1F0 U+1F1FC",
    "id": "307bd130-c2c6-4bfe-99e3-6635f3137b4e",
    "iso2": "KW",
    "iso3": "KWT",
    "locationTranslations": {
      "de": "Kuwait",
      "en": "Kuwait",
      "fr": "Koweït",
      "tr": "Kuveyt"
    },
    "name": "Kuwait",
    "native": "الكويت",
    "phoneCode": "965",
    "region": "Asia",
    "subregion": "Western Asia",
    "updatedAt": 1657792799468
  },
  {
    "capital": "Pyongyang",
    "createdAt": 1604406817998,
    "currency": "KPW",
    "currencyCode": "KPW",
    "currencySymbol": "₩",
    "deleted": false,
    "emoji": "🇰🇵",
    "emojiString": "U+1F1F0 U+1F1F5",
    "id": "3d1c8520-6c78-406c-9c07-84a9fded072f",
    "iso2": "KP",
    "iso3": "PRK",
    "locationTranslations": {
      "de": "Korea, Nord",
      "en": "Korea North",
      "fr": "République Populaire Démocratique De Corée",
      "tr": "Kuzey Kore"
    },
    "name": "Korea North",
    "native": "북한",
    "phoneCode": "850",
    "region": "Asia",
    "subregion": "Eastern Asia",
    "updatedAt": 1657792800451
  },
  {
    "capital": "Saipan",
    "createdAt": 1604406817999,
    "currency": "USD",
    "currencyCode": "USD",
    "currencySymbol": "$",
    "deleted": false,
    "emoji": "🇲🇵",
    "emojiString": "U+1F1F2 U+1F1F5",
    "id": "ffbefdc3-b4c2-4bbe-8f15-fdd47d8f61d3",
    "iso2": "MP",
    "iso3": "MNP",
    "locationTranslations": {
      "de": "Nördliche Marianen",
      "en": "Northern Mariana Islands",
      "fr": "Îles Mariannes Du Nord",
      "tr": "Kuzey Mariana Adaları"
    },
    "name": "Northern Mariana Islands",
    "native": "Northern Mariana Islands",
    "phoneCode": "+1-670",
    "region": "Oceania",
    "subregion": "Micronesia",
    "updatedAt": 1658414430671
  },
  {
    "capital": "Havana",
    "createdAt": 1604406817997,
    "currency": "CUP",
    "currencyCode": "CUP",
    "currencySymbol": "$MN",
    "deleted": false,
    "emoji": "🇨🇺",
    "emojiString": "U+1F1E8 U+1F1FA",
    "id": "1d5325ba-a07c-46cc-92c8-5764b4482538",
    "iso2": "CU",
    "iso3": "CUB",
    "locationTranslations": {
      "de": "Kuba",
      "en": "Cuba",
      "fr": "Cuba",
      "tr": "Küba"
    },
    "name": "Cuba",
    "native": "Cuba",
    "phoneCode": "53",
    "region": "Americas",
    "subregion": "Caribbean",
    "updatedAt": 1657792793810
  },
  {
    "capital": "Vientiane",
    "createdAt": 1604406817998,
    "currency": "LAK",
    "currencyCode": "LAK",
    "currencySymbol": "₭N",
    "deleted": false,
    "emoji": "🇱🇦",
    "emojiString": "U+1F1F1 U+1F1E6",
    "id": "dac8f17d-8163-4d2f-bceb-3bb148ac7166",
    "iso2": "LA",
    "iso3": "LAO",
    "locationTranslations": {
      "de": "Laos",
      "en": "Laos",
      "fr": "République Démocratique Populaire Lao",
      "tr": "Laos"
    },
    "name": "Laos",
    "native": "ສປປລາວ",
    "phoneCode": "856",
    "region": "Asia",
    "subregion": "South-Eastern Asia",
    "updatedAt": 1657792805491
  },
  {
    "capital": "Maseru",
    "createdAt": 1604406817998,
    "currency": "LSL",
    "currencyCode": "LSL",
    "currencySymbol": "L",
    "deleted": false,
    "emoji": "🇱🇸",
    "emojiString": "U+1F1F1 U+1F1F8",
    "id": "7b606d77-5ae4-4144-ad65-0506fa1000ab",
    "iso2": "LS",
    "iso3": "LSO",
    "locationTranslations": {
      "de": "Lesotho",
      "en": "Lesotho",
      "fr": "Lesotho",
      "tr": "Lesotho"
    },
    "name": "Lesotho",
    "native": "Lesotho",
    "phoneCode": "266",
    "region": "Africa",
    "subregion": "Southern Africa",
    "updatedAt": 1657792797396
  },
  {
    "capital": "Riga",
    "createdAt": 1604406817998,
    "currency": "EUR",
    "currencyCode": "EUR",
    "currencySymbol": "€",
    "deleted": false,
    "emoji": "🇱🇻",
    "emojiString": "U+1F1F1 U+1F1FB",
    "id": "36839e8b-2650-4d42-9b3c-1dcc3e32f96a",
    "iso2": "LV",
    "iso3": "LVA",
    "locationTranslations": {
      "de": "Lettland",
      "en": "Latvia",
      "fr": "Lettonie",
      "tr": "Letonya"
    },
    "name": "Latvia",
    "native": "Latvija",
    "phoneCode": "371",
    "region": "Europe",
    "subregion": "Northern Europe",
    "updatedAt": 1657792799837
  },
  {
    "capital": "Monrovia",
    "createdAt": 1604406817998,
    "currency": "LRD",
    "currencyCode": "LRD",
    "currencySymbol": "L$",
    "deleted": false,
    "emoji": "🇱🇷",
    "emojiString": "U+1F1F1 U+1F1F7",
    "id": "f15d175b-e159-4324-9bbf-f9c7af65f81b",
    "iso2": "LR",
    "iso3": "LBR",
    "locationTranslations": {
      "de": "Liberia",
      "en": "Liberia",
      "fr": "Liberia",
      "tr": "Liberya"
    },
    "name": "Liberia",
    "native": "Liberia",
    "phoneCode": "231",
    "region": "Africa",
    "subregion": "Western Africa",
    "updatedAt": 1657792799184
  },
  {
    "capital": "Tripolis",
    "createdAt": 1604406817998,
    "currency": "LYD",
    "currencyCode": "LYD",
    "currencySymbol": "LD",
    "deleted": false,
    "emoji": "🇱🇾",
    "emojiString": "U+1F1F1 U+1F1FE",
    "id": "3a122263-5099-4ce8-9282-fe4bb4215e12",
    "iso2": "LY",
    "iso3": "LBY",
    "locationTranslations": {
      "de": "Libyen",
      "en": "Libya",
      "fr": "Libye",
      "tr": "Libya"
    },
    "name": "Libya",
    "native": "‏ليبيا",
    "phoneCode": "218",
    "region": "Africa",
    "subregion": "Northern Africa",
    "updatedAt": 1657792809444
  },
  {
    "capital": "Vaduz",
    "createdAt": 1604406817998,
    "currency": "CHF",
    "currencyCode": "CHF",
    "currencySymbol": "CHF",
    "deleted": false,
    "emoji": "🇱🇮",
    "emojiString": "U+1F1F1 U+1F1EE",
    "id": "2936936a-f226-4021-a12e-78931d29d66b",
    "iso2": "LI",
    "iso3": "LIE",
    "locationTranslations": {
      "de": "Liechtenstein",
      "en": "Liechtenstein",
      "fr": "Liechtenstein",
      "tr": "Liechtenstein"
    },
    "name": "Liechtenstein",
    "native": "Liechtenstein",
    "phoneCode": "423",
    "region": "Europe",
    "subregion": "Western Europe",
    "updatedAt": 1657792802617
  },
  {
    "capital": "Vilnius",
    "createdAt": 1604406817998,
    "currency": "EUR",
    "currencyCode": "EUR",
    "currencySymbol": "€",
    "deleted": false,
    "emoji": "🇱🇹",
    "emojiString": "U+1F1F1 U+1F1F9",
    "id": "5cba0119-3f05-4c2a-aae6-ad2d3c8aa4e9",
    "iso2": "LT",
    "iso3": "LTU",
    "locationTranslations": {
      "de": "Litauen",
      "en": "Lithuania",
      "fr": "Lituanie",
      "tr": "Litvanya"
    },
    "name": "Lithuania",
    "native": "Lietuva",
    "phoneCode": "370",
    "region": "Europe",
    "subregion": "Northern Europe",
    "updatedAt": 1657792805582
  },
  {
    "capital": "Beirut",
    "createdAt": 1604406817998,
    "currency": "LBP",
    "currencyCode": "LBP",
    "currencySymbol": "LL.",
    "deleted": false,
    "emoji": "🇱🇧",
    "emojiString": "U+1F1F1 U+1F1E7",
    "id": "9fd8289f-4587-4ef0-81c5-e4ce6c33a3b7",
    "iso2": "LB",
    "iso3": "LBN",
    "locationTranslations": {
      "de": "Libanon",
      "en": "Lebanon",
      "fr": "Liban",
      "tr": "Lübnan"
    },
    "name": "Lebanon",
    "native": "لبنان",
    "phoneCode": "961",
    "region": "Asia",
    "subregion": "Western Asia",
    "updatedAt": 1657792804212
  },
  {
    "capital": "Luxembourg",
    "createdAt": 1604406817999,
    "currency": "EUR",
    "currencyCode": "EUR",
    "currencySymbol": "€",
    "deleted": false,
    "emoji": "🇱🇺",
    "emojiString": "U+1F1F1 U+1F1FA",
    "id": "02bb6e5d-ddf7-43df-8152-d622723bdb24",
    "iso2": "LU",
    "iso3": "LUX",
    "locationTranslations": {
      "de": "Luxemburg",
      "en": "Luxembourg",
      "fr": "Luxembourg",
      "tr": "Lüksemburg"
    },
    "name": "Luxembourg",
    "native": "Luxembourg",
    "phoneCode": "352",
    "region": "Europe",
    "subregion": "Western Europe",
    "updatedAt": 1657792801247
  },
  {
    "capital": "Budapest",
    "createdAt": 1604406817998,
    "currency": "HUF",
    "currencyCode": "HUF",
    "currencySymbol": "Ft",
    "deleted": false,
    "emoji": "🇭🇺",
    "emojiString": "U+1F1ED U+1F1FA",
    "id": "36c5ee6b-f650-4fb6-a0cb-d92282530b40",
    "iso2": "HU",
    "iso3": "HUN",
    "locationTranslations": {
      "de": "Ungarn",
      "en": "Hungary",
      "fr": "Hongrie",
      "tr": "Macaristan"
    },
    "name": "Hungary",
    "native": "Magyarország",
    "phoneCode": "36",
    "region": "Europe",
    "subregion": "Eastern Europe",
    "updatedAt": 1657792798902
  },
  {
    "capital": "Antananarivo",
    "createdAt": 1604406817999,
    "currency": "MGA",
    "currencyCode": "MGA",
    "currencySymbol": "Ar",
    "deleted": false,
    "emoji": "🇲🇬",
    "emojiString": "U+1F1F2 U+1F1EC",
    "id": "5d369ec6-d361-44c8-b0df-b8a54cba305d",
    "iso2": "MG",
    "iso3": "MDG",
    "locationTranslations": {
      "de": "Madagaskar",
      "en": "Madagascar",
      "fr": "Madagascar",
      "tr": "Madagaskar"
    },
    "name": "Madagascar",
    "native": "Madagasikara",
    "phoneCode": "261",
    "region": "Africa",
    "subregion": "Eastern Africa",
    "updatedAt": 1657792797227
  },
  {
    "capital": "Macao",
    "createdAt": 1604406817999,
    "currency": "MOP",
    "currencyCode": "MOP",
    "currencySymbol": "MOP$",
    "deleted": false,
    "emoji": "🇲🇴",
    "emojiString": "U+1F1F2 U+1F1F4",
    "id": "6d6b6359-4f80-43d0-b817-0ca4da3d49e8",
    "iso2": "MO",
    "iso3": "MAC",
    "locationTranslations": {
      "de": "Macaud",
      "en": "Macau S.A.R.",
      "fr": "Macao",
      "tr": "Makao"
    },
    "name": "Macau S.A.R.",
    "native": "澳門",
    "phoneCode": "853",
    "region": "Asia",
    "subregion": "Eastern Asia",
    "updatedAt": 1658414430554
  },
  {
    "capital": "Skopje",
    "createdAt": 1604406817999,
    "currency": "MKD",
    "currencyCode": "MKD",
    "currencySymbol": "den",
    "deleted": false,
    "emoji": "🇲🇰",
    "emojiString": "U+1F1F2 U+1F1F0",
    "id": "2c3529e7-14a4-48c4-9efd-c3272797bfd0",
    "iso2": "MK",
    "iso3": "MKD",
    "locationTranslations": {
      "de": "Nordmazedonien",
      "en": "Macedonia",
      "fr": "Macédoine",
      "tr": "Makedonya"
    },
    "name": "Macedonia",
    "native": "Северна Македонија",
    "phoneCode": "389",
    "region": "Europe",
    "subregion": "Southern Europe",
    "updatedAt": 1657792800895
  },
  {
    "capital": "Lilongwe",
    "createdAt": 1604406817999,
    "currency": "MWK",
    "currencyCode": "MWK",
    "currencySymbol": "MK",
    "deleted": false,
    "emoji": "🇲🇼",
    "emojiString": "U+1F1F2 U+1F1FC",
    "id": "bf0f7c93-fd97-4465-b872-02ed2d04932a",
    "iso2": "MW",
    "iso3": "MWI",
    "locationTranslations": {
      "de": "Malawi",
      "en": "Malawi",
      "fr": "Malawi",
      "tr": "Malavi"
    },
    "name": "Malawi",
    "native": "Malawi",
    "phoneCode": "265",
    "region": "Africa",
    "subregion": "Eastern Africa",
    "updatedAt": 1657792808404
  },
  {
    "capital": "Male",
    "createdAt": 1604406817999,
    "currency": "MVR",
    "currencyCode": "MVR",
    "currencySymbol": "MRf",
    "deleted": false,
    "emoji": "🇲🇻",
    "emojiString": "U+1F1F2 U+1F1FB",
    "id": "b416925b-316a-4f51-a8b1-3aff4fd06dd7",
    "iso2": "MV",
    "iso3": "MDV",
    "locationTranslations": {
      "de": "Malediven",
      "en": "Maldives",
      "fr": "Maldives",
      "tr": "Maldivler"
    },
    "name": "Maldives",
    "native": "Maldives",
    "phoneCode": "960",
    "region": "Asia",
    "subregion": "Southern Asia",
    "updatedAt": 1657792798088
  },
  {
    "capital": "Kuala Lumpur",
    "createdAt": 1604406817999,
    "currency": "MYR",
    "currencyCode": "MYR",
    "currencySymbol": "RM",
    "deleted": false,
    "emoji": "🇲🇾",
    "emojiString": "U+1F1F2 U+1F1FE",
    "id": "cd30069b-5132-4af6-9124-fd096902ab73",
    "iso2": "MY",
    "iso3": "MYS",
    "locationTranslations": {
      "de": "Malaysia",
      "en": "Malaysia",
      "fr": "Malaisie",
      "tr": "Malezya"
    },
    "name": "Malaysia",
    "native": "Malaysia",
    "phoneCode": "60",
    "region": "Asia",
    "subregion": "South-Eastern Asia",
    "updatedAt": 1657792796896
  },
  {
    "capital": "Bamako",
    "createdAt": 1604406817999,
    "currency": "XOF",
    "currencyCode": "XOF",
    "currencySymbol": "₣",
    "deleted": false,
    "emoji": "🇲🇱",
    "emojiString": "U+1F1F2 U+1F1F1",
    "id": "3b2b6e46-eed6-4267-ae3b-925848d2471c",
    "iso2": "ML",
    "iso3": "MLI",
    "locationTranslations": {
      "de": "Mali",
      "en": "Mali",
      "fr": "Mali",
      "tr": "Mali"
    },
    "name": "Mali",
    "native": "Mali",
    "phoneCode": "223",
    "region": "Africa",
    "subregion": "Western Africa",
    "updatedAt": 1657792802959
  },
  {
    "capital": "Valletta",
    "createdAt": 1604406817999,
    "currency": "EUR",
    "currencyCode": "EUR",
    "currencySymbol": "€",
    "deleted": false,
    "emoji": "🇲🇹",
    "emojiString": "U+1F1F2 U+1F1F9",
    "id": "457af4aa-6ec0-441d-9174-7934eae9eecb",
    "iso2": "MT",
    "iso3": "MLT",
    "locationTranslations": {
      "de": "Malta",
      "en": "Malta",
      "fr": "Malte",
      "tr": "Malta"
    },
    "name": "Malta",
    "native": "Malta",
    "phoneCode": "356",
    "region": "Europe",
    "subregion": "Southern Europe",
    "updatedAt": 1657792798369
  },
  {
    "capital": "Douglas, Isle of Man",
    "createdAt": 1604406817999,
    "currency": "GBP",
    "currencyCode": "GBP",
    "currencySymbol": "£",
    "deleted": false,
    "emoji": "🇮🇲",
    "emojiString": "U+1F1EE U+1F1F2",
    "id": "f19ba306-6e25-4a89-92f0-c5411826a2a0",
    "iso2": "IM",
    "iso3": "IMN",
    "locationTranslations": {
      "de": "Isle of Man",
      "en": "Man (Isle of)",
      "fr": "Île De Man",
      "tr": "Man Adası"
    },
    "name": "Man (Isle of)",
    "native": "Isle of Man",
    "phoneCode": "+44-1624",
    "region": "Europe",
    "subregion": "Northern Europe",
    "updatedAt": 1658414432421
  },
  {
    "capital": "Majuro",
    "createdAt": 1604406817999,
    "currency": "USD",
    "currencyCode": "USD",
    "currencySymbol": "$",
    "deleted": false,
    "emoji": "🇲🇭",
    "emojiString": "U+1F1F2 U+1F1ED",
    "id": "74b70d9d-941e-4ffb-906f-475f5ea30fa7",
    "iso2": "MH",
    "iso3": "MHL",
    "locationTranslations": {
      "de": "Marshallinseln",
      "en": "Marshall Islands",
      "fr": "Îles Marshall",
      "tr": "Marshall Adaları"
    },
    "name": "Marshall Islands",
    "native": "M̧ajeļ",
    "phoneCode": "692",
    "region": "Oceania",
    "subregion": "Micronesia",
    "updatedAt": 1657792798189
  },
  {
    "capital": "Fort-de-France",
    "createdAt": 1604406817999,
    "currency": "EUR",
    "currencyCode": "EUR",
    "currencySymbol": "€",
    "deleted": false,
    "emoji": "🇲🇶",
    "emojiString": "U+1F1F2 U+1F1F6",
    "id": "e71f5658-211b-4190-8782-5ca01a25d69c",
    "iso2": "MQ",
    "iso3": "MTQ",
    "locationTranslations": {
      "de": "Martinique",
      "en": "Martinique",
      "fr": "Martinique",
      "tr": "Martinik"
    },
    "name": "Martinique",
    "native": "Martinique",
    "phoneCode": "596",
    "region": "Americas",
    "subregion": "Caribbean",
    "updatedAt": 1658414431427
  },
  {
    "capital": "Port Louis",
    "createdAt": 1604406817999,
    "currency": "MUR",
    "currencyCode": "MUR",
    "currencySymbol": "Rs.",
    "deleted": false,
    "emoji": "🇲🇺",
    "emojiString": "U+1F1F2 U+1F1FA",
    "id": "35d54b7f-4c03-4bb3-8789-d2f593085a6d",
    "iso2": "MU",
    "iso3": "MUS",
    "locationTranslations": {
      "de": "Mauritius",
      "en": "Mauritius",
      "fr": "Maurice",
      "tr": "Mauritius"
    },
    "name": "Mauritius",
    "native": "Maurice",
    "phoneCode": "230",
    "region": "Africa",
    "subregion": "Eastern Africa",
    "updatedAt": 1657792805663
  },
  {
    "capital": "Mamoudzou",
    "createdAt": 1604406817999,
    "currency": "EUR",
    "currencyCode": "EUR",
    "currencySymbol": "€",
    "deleted": false,
    "emoji": "🇾🇹",
    "emojiString": "U+1F1FE U+1F1F9",
    "id": "12ee1c4b-75a9-44f3-9526-6cc4b1fff2aa",
    "iso2": "YT",
    "iso3": "MYT",
    "locationTranslations": {
      "de": "Mayotte",
      "en": "Mayotte",
      "fr": "Mayotte",
      "tr": "Mayotte"
    },
    "name": "Mayotte",
    "native": "Mayotte",
    "phoneCode": "262",
    "region": "Africa",
    "subregion": "Eastern Africa",
    "updatedAt": 1658414431545
  },
  {
    "capital": "Mexico City",
    "createdAt": 1604406817999,
    "currency": "MXN",
    "currencyCode": "MXN",
    "currencySymbol": "MX$",
    "deleted": false,
    "emoji": "🇲🇽",
    "emojiString": "U+1F1F2 U+1F1FD",
    "id": "6b45ebeb-bcec-461a-8faf-dcc2daefe24b",
    "iso2": "MX",
    "iso3": "MEX",
    "locationTranslations": {
      "de": "Mexiko",
      "en": "Mexico",
      "fr": "Mexique",
      "tr": "Meksika"
    },
    "name": "Mexico",
    "native": "México",
    "phoneCode": "52",
    "region": "Americas",
    "subregion": "Central America",
    "updatedAt": 1657792807231
  },
  {
    "capital": "Cairo",
    "createdAt": 1604406817997,
    "currency": "EGP",
    "currencyCode": "EGP",
    "currencySymbol": "E£",
    "deleted": false,
    "emoji": "🇪🇬",
    "emojiString": "U+1F1EA U+1F1EC",
    "id": "ba74009f-118f-403b-bcd6-054747f96a0e",
    "iso2": "EG",
    "iso3": "EGY",
    "locationTranslations": {
      "de": "Ägypten",
      "en": "Egypt",
      "fr": "Égypte",
      "tr": "Mısır"
    },
    "name": "Egypt",
    "native": "مصر‎",
    "phoneCode": "20",
    "region": "Africa",
    "subregion": "Northern Africa",
    "updatedAt": 1657792802510
  },
  {
    "capital": "Palikir",
    "createdAt": 1604406817999,
    "currency": "USD",
    "currencyCode": "USD",
    "currencySymbol": "$",
    "deleted": false,
    "emoji": "🇫🇲",
    "emojiString": "U+1F1EB U+1F1F2",
    "id": "8ba59b6e-a0b9-4359-9ab4-d4ab740968e1",
    "iso2": "FM",
    "iso3": "FSM",
    "locationTranslations": {
      "de": "Mikronesien",
      "en": "Micronesia",
      "fr": "États Fédérés De Micronésie",
      "tr": "Mikronezya"
    },
    "name": "Micronesia",
    "native": "Micronesia",
    "phoneCode": "691",
    "region": "Oceania",
    "subregion": "Micronesia",
    "updatedAt": 1657792808231
  },
  {
    "capital": "Ulan Bator",
    "createdAt": 1604406817999,
    "currency": "MNT",
    "currencyCode": "MNT",
    "currencySymbol": "₮",
    "deleted": false,
    "emoji": "🇲🇳",
    "emojiString": "U+1F1F2 U+1F1F3",
    "id": "e2550f20-3b7b-498f-9adf-2416c06c667e",
    "iso2": "MN",
    "iso3": "MNG",
    "locationTranslations": {
      "de": "Mongolei",
      "en": "Mongolia",
      "fr": "Mongolie",
      "tr": "Moğolistan"
    },
    "name": "Mongolia",
    "native": "Монгол улс",
    "phoneCode": "976",
    "region": "Asia",
    "subregion": "Eastern Asia",
    "updatedAt": 1657792803743
  },
  {
    "capital": "Chisinau",
    "createdAt": 1604406817999,
    "currency": "MDL",
    "currencyCode": "MDL",
    "currencySymbol": "L",
    "deleted": false,
    "emoji": "🇲🇩",
    "emojiString": "U+1F1F2 U+1F1E9",
    "id": "d90833c8-0671-4c7e-a6c9-ce0973f16f06",
    "iso2": "MD",
    "iso3": "MDA",
    "locationTranslations": {
      "de": "Moldau",
      "en": "Moldova",
      "fr": "République De Moldavie",
      "tr": "Moldova"
    },
    "name": "Moldova",
    "native": "Moldova",
    "phoneCode": "373",
    "region": "Europe",
    "subregion": "Eastern Europe",
    "updatedAt": 1657792801611
  },
  {
    "capital": "Monaco",
    "createdAt": 1604406817999,
    "currency": "EUR",
    "currencyCode": "EUR",
    "currencySymbol": "€",
    "deleted": false,
    "emoji": "🇲🇨",
    "emojiString": "U+1F1F2 U+1F1E8",
    "id": "7d27de0c-13d2-4db3-a08a-37497fa11b50",
    "iso2": "MC",
    "iso3": "MCO",
    "locationTranslations": {
      "de": "Monaco",
      "en": "Monaco",
      "fr": "Monaco",
      "tr": "Monako"
    },
    "name": "Monaco",
    "native": "Monaco",
    "phoneCode": "377",
    "region": "Europe",
    "subregion": "Western Europe",
    "updatedAt": 1657792797747
  },
  {
    "capital": "Plymouth",
    "createdAt": 1604406817999,
    "currency": "XCD",
    "currencyCode": "XCD",
    "currencySymbol": "$",
    "deleted": false,
    "emoji": "🇲🇸",
    "emojiString": "U+1F1F2 U+1F1F8",
    "id": "e44d800b-eb9b-41fe-8651-feedbc75510a",
    "iso2": "MS",
    "iso3": "MSR",
    "locationTranslations": {
      "de": "Montserrat",
      "en": "Montserrat",
      "fr": "Montserrat",
      "tr": "Montserrat"
    },
    "name": "Montserrat",
    "native": "Montserrat",
    "phoneCode": "+1-664",
    "region": "Americas",
    "subregion": "Caribbean",
    "updatedAt": 1658414432307
  },
  {
    "capital": "Nouakchott",
    "createdAt": 1604406817999,
    "currency": "MRO",
    "currencyCode": "MRO",
    "currencySymbol": "UM",
    "deleted": false,
    "emoji": "🇲🇷",
    "emojiString": "U+1F1F2 U+1F1F7",
    "id": "d84e2c0c-ad6f-4648-9a83-a1483ed8e545",
    "iso2": "MR",
    "iso3": "MRT",
    "locationTranslations": {
      "de": "Mauretanien",
      "en": "Mauritania",
      "fr": "Mauritanie",
      "tr": "Moritanya"
    },
    "name": "Mauritania",
    "native": "موريتانيا",
    "phoneCode": "222",
    "region": "Africa",
    "subregion": "Western Africa",
    "updatedAt": 1657792799104
  },
  {
    "capital": "Maputo",
    "createdAt": 1604406817999,
    "currency": "MZN",
    "currencyCode": "MZN",
    "currencySymbol": "MTn",
    "deleted": false,
    "emoji": "🇲🇿",
    "emojiString": "U+1F1F2 U+1F1FF",
    "id": "6987815c-ddc6-4fc1-8b57-f42adfc666bc",
    "iso2": "MZ",
    "iso3": "MOZ",
    "locationTranslations": {
      "de": "Mosambik",
      "en": "Mozambique",
      "fr": "Mozambique",
      "tr": "Mozambik"
    },
    "name": "Mozambique",
    "native": "Moçambique",
    "phoneCode": "258",
    "region": "Africa",
    "subregion": "Eastern Africa",
    "updatedAt": 1657792799925
  },
  {
    "capital": "Nay Pyi Taw",
    "createdAt": 1604406817999,
    "currency": "MMK",
    "currencyCode": "MMK",
    "currencySymbol": "Ks",
    "deleted": false,
    "emoji": "🇲🇲",
    "emojiString": "U+1F1F2 U+1F1F2",
    "id": "58a87d44-d339-41dd-ad08-28c49dee5ae7",
    "iso2": "MM",
    "iso3": "MMR",
    "locationTranslations": {
      "de": "Myanmar",
      "en": "Myanmar",
      "fr": "Birmanie",
      "tr": "Myanmar"
    },
    "name": "Myanmar",
    "native": "မြန်မာ",
    "phoneCode": "95",
    "region": "Asia",
    "subregion": "South-Eastern Asia",
    "updatedAt": 1657792796812
  },
  {
    "capital": "Windhoek",
    "createdAt": 1604406817999,
    "currency": "NAD",
    "currencyCode": "NAD",
    "currencySymbol": "N$",
    "deleted": false,
    "emoji": "🇳🇦",
    "emojiString": "U+1F1F3 U+1F1E6",
    "id": "f509f322-4122-416a-96ea-b790bd449645",
    "iso2": "NA",
    "iso3": "NAM",
    "locationTranslations": {
      "de": "Namibia",
      "en": "Namibia",
      "fr": "Namibie",
      "tr": "Namibya"
    },
    "name": "Namibia",
    "native": "Namibia",
    "phoneCode": "264",
    "region": "Africa",
    "subregion": "Southern Africa",
    "updatedAt": 1657792799375
  },
  {
    "capital": "Yaren",
    "createdAt": 1604406817999,
    "currency": "AUD",
    "currencyCode": "AUD",
    "currencySymbol": "AU$",
    "deleted": false,
    "emoji": "🇳🇷",
    "emojiString": "U+1F1F3 U+1F1F7",
    "id": "3a631666-d068-4335-a2d0-ee0e7dbd97bd",
    "iso2": "NR",
    "iso3": "NRU",
    "locationTranslations": {
      "de": "Nauru",
      "en": "Nauru",
      "fr": "Nauru",
      "tr": "Nauru"
    },
    "name": "Nauru",
    "native": "Nauru",
    "phoneCode": "674",
    "region": "Oceania",
    "subregion": "Micronesia",
    "updatedAt": 1657792807494
  },
  {
    "capital": "Kathmandu",
    "createdAt": 1604406817999,
    "currency": "NPR",
    "currencyCode": "NPR",
    "currencySymbol": "Rs.",
    "deleted": false,
    "emoji": "🇳🇵",
    "emojiString": "U+1F1F3 U+1F1F5",
    "id": "28e965da-d859-4423-9e36-352cc390bd40",
    "iso2": "NP",
    "iso3": "NPL",
    "locationTranslations": {
      "de": "Nepal",
      "en": "Nepal",
      "fr": "Népal",
      "tr": "Nepal"
    },
    "name": "Nepal",
    "native": "नपल",
    "phoneCode": "977",
    "region": "Asia",
    "subregion": "Southern Asia",
    "updatedAt": 1657792799292
  },
  {
    "capital": "Niamey",
    "createdAt": 1604406817999,
    "currency": "XOF",
    "currencyCode": "XOF",
    "currencySymbol": "₣",
    "deleted": false,
    "emoji": "🇳🇪",
    "emojiString": "U+1F1F3 U+1F1EA",
    "id": "02263e93-a82d-4b76-a891-9b82661f371c",
    "iso2": "NE",
    "iso3": "NER",
    "locationTranslations": {
      "de": "Niger",
      "en": "Niger",
      "fr": "Niger",
      "tr": "Nijer"
    },
    "name": "Niger",
    "native": "Niger",
    "phoneCode": "227",
    "region": "Africa",
    "subregion": "Western Africa",
    "updatedAt": 1657792804671
  },
  {
    "capital": "Abuja",
    "createdAt": 1604406817999,
    "currency": "NGN",
    "currencyCode": "NGN",
    "currencySymbol": "₦",
    "deleted": false,
    "emoji": "🇳🇬",
    "emojiString": "U+1F1F3 U+1F1EC",
    "id": "a47547d2-32bf-471d-9d3f-c7cc07dbe8f3",
    "iso2": "NG",
    "iso3": "NGA",
    "locationTranslations": {
      "de": "Nigeria",
      "en": "Nigeria",
      "fr": "Nigéria",
      "tr": "Nijerya"
    },
    "name": "Nigeria",
    "native": "Nigeria",
    "phoneCode": "234",
    "region": "Africa",
    "subregion": "Western Africa",
    "updatedAt": 1657792800816
  },
  {
    "capital": "Managua",
    "createdAt": 1604406817999,
    "currency": "NIO",
    "currencyCode": "NIO",
    "currencySymbol": "C$",
    "deleted": false,
    "emoji": "🇳🇮",
    "emojiString": "U+1F1F3 U+1F1EE",
    "id": "1b701775-f8a4-4ea8-9b28-fa17d4e6d799",
    "iso2": "NI",
    "iso3": "NIC",
    "locationTranslations": {
      "de": "Nicaragua",
      "en": "Nicaragua",
      "fr": "Nicaragua",
      "tr": "Nikaragua"
    },
    "name": "Nicaragua",
    "native": "Nicaragua",
    "phoneCode": "505",
    "region": "Americas",
    "subregion": "Central America",
    "updatedAt": 1657792797827
  },
  {
    "capital": "Alofi",
    "createdAt": 1604406817999,
    "currency": "NZD",
    "currencyCode": "NZD",
    "currencySymbol": "NZ$",
    "deleted": false,
    "emoji": "🇳🇺",
    "emojiString": "U+1F1F3 U+1F1FA",
    "id": "ac531973-bf55-4a87-a72a-8a673a2c4d30",
    "iso2": "NU",
    "iso3": "NIU",
    "locationTranslations": {
      "de": "Niue",
      "en": "Niue",
      "fr": "Niue",
      "tr": "Niue"
    },
    "name": "Niue",
    "native": "Niuē",
    "phoneCode": "683",
    "region": "Oceania",
    "subregion": "Polynesia",
    "updatedAt": 1658414432479
  },
  {
    "capital": "Kingston",
    "createdAt": 1604406817999,
    "currency": "AUD",
    "currencyCode": "AUD",
    "currencySymbol": "AU$",
    "deleted": false,
    "emoji": "🇳🇫",
    "emojiString": "U+1F1F3 U+1F1EB",
    "id": "1c012e10-5acd-4260-9fd7-cef3588728ce",
    "iso2": "NF",
    "iso3": "NFK",
    "locationTranslations": {
      "de": "Norfolkinsel",
      "en": "Norfolk Island",
      "fr": "Île Norfolk",
      "tr": "Norfolk Adası"
    },
    "name": "Norfolk Island",
    "native": "Norfolk Island",
    "phoneCode": "672",
    "region": "Oceania",
    "subregion": "Australia and New Zealand",
    "updatedAt": 1658414430786
  },
  {
    "capital": "Oslo",
    "createdAt": 1604406817999,
    "currency": "NOK",
    "currencyCode": "NOK",
    "currencySymbol": "kr",
    "deleted": false,
    "emoji": "🇳🇴",
    "emojiString": "U+1F1F3 U+1F1F4",
    "id": "9dd77df2-fec1-4e28-bf8c-5c2a3b4063c3",
    "iso2": "NO",
    "iso3": "NOR",
    "locationTranslations": {
      "de": "Norwegen",
      "en": "Norway",
      "fr": "Norvège",
      "tr": "Norveç"
    },
    "name": "Norway",
    "native": "Norge",
    "phoneCode": "47",
    "region": "Europe",
    "subregion": "Northern Europe",
    "updatedAt": 1657792801529
  },
  {
    "capital": "Bangui",
    "createdAt": 1604406817997,
    "currency": "XAF",
    "currencyCode": "XAF",
    "currencySymbol": "Fr",
    "deleted": false,
    "emoji": "🇨🇫",
    "emojiString": "U+1F1E8 U+1F1EB",
    "id": "774cb8b0-f0ef-4d33-a485-198cbafe2267",
    "iso2": "CF",
    "iso3": "CAF",
    "locationTranslations": {
      "de": "Zentralafrikanische Republik",
      "en": "Central African Republic",
      "fr": "République Centrafricaine",
      "tr": "Orta Afrika Cumhuriyeti"
    },
    "name": "Central African Republic",
    "native": "Ködörösêse tî Bêafrîka",
    "phoneCode": "236",
    "region": "Africa",
    "subregion": "Middle Africa",
    "updatedAt": 1657792796384
  },
  {
    "capital": "Tashkent",
    "createdAt": 1604406818002,
    "currency": "UZS",
    "currencyCode": "UZS",
    "currencySymbol": "сум",
    "deleted": false,
    "emoji": "🇺🇿",
    "emojiString": "U+1F1FA U+1F1FF",
    "id": "86c5e792-82c0-430a-80d3-e7905289725d",
    "iso2": "UZ",
    "iso3": "UZB",
    "locationTranslations": {
      "de": "Usbekistan",
      "en": "Uzbekistan",
      "fr": "Ouzbékistan",
      "tr": "Özbekistan"
    },
    "name": "Uzbekistan",
    "native": "O‘zbekiston",
    "phoneCode": "998",
    "region": "Asia",
    "subregion": "Central Asia",
    "updatedAt": 1657792806682
  },
  {
    "capital": "Islamabad",
    "createdAt": 1604406817999,
    "currency": "PKR",
    "currencyCode": "PKR",
    "currencySymbol": "Rs.",
    "deleted": false,
    "emoji": "🇵🇰",
    "emojiString": "U+1F1F5 U+1F1F0",
    "id": "304b9b15-7d51-4217-bc1f-a21eb2ac3a6d",
    "iso2": "PK",
    "iso3": "PAK",
    "locationTranslations": {
      "de": "Pakistan",
      "en": "Pakistan",
      "fr": "Pakistan",
      "tr": "Pakistan"
    },
    "name": "Pakistan",
    "native": "Pakistan",
    "phoneCode": "92",
    "region": "Asia",
    "subregion": "Southern Asia",
    "updatedAt": 1657792806972
  },
  {
    "capital": "Melekeok",
    "createdAt": 1604406817999,
    "currency": "USD",
    "currencyCode": "USD",
    "currencySymbol": "$",
    "deleted": false,
    "emoji": "🇵🇼",
    "emojiString": "U+1F1F5 U+1F1FC",
    "id": "cdf97d66-9ac5-4d13-9713-8cd804dc9d23",
    "iso2": "PW",
    "iso3": "PLW",
    "locationTranslations": {
      "de": "Palau",
      "en": "Palau",
      "fr": "Palaos",
      "tr": "Palau"
    },
    "name": "Palau",
    "native": "Palau",
    "phoneCode": "680",
    "region": "Oceania",
    "subregion": "Micronesia",
    "updatedAt": 1657792806392
  },
  {
    "capital": "Panama City",
    "createdAt": 1604406818000,
    "currency": "PAB",
    "currencyCode": "PAB",
    "currencySymbol": "B/.",
    "deleted": false,
    "emoji": "🇵🇦",
    "emojiString": "U+1F1F5 U+1F1E6",
    "id": "bf3749a7-f90d-4a98-99c9-1d40f2d16990",
    "iso2": "PA",
    "iso3": "PAN",
    "locationTranslations": {
      "de": "Panama",
      "en": "Panama",
      "fr": "Panama",
      "tr": "Panama"
    },
    "name": "Panama",
    "native": "Panamá",
    "phoneCode": "507",
    "region": "Americas",
    "subregion": "Central America",
    "updatedAt": 1657792801155
  },
  {
    "capital": "Port Moresby",
    "createdAt": 1604406818000,
    "currency": "PGK",
    "currencyCode": "PGK",
    "currencySymbol": "K",
    "deleted": false,
    "emoji": "🇵🇬",
    "emojiString": "U+1F1F5 U+1F1EC",
    "id": "46023573-c69e-4df5-a454-f712a116f0bd",
    "iso2": "PG",
    "iso3": "PNG",
    "locationTranslations": {
      "de": "Papua-Neuguinea",
      "en": "Papua new Guinea",
      "fr": "Papouasie-Nouvelle-Guinée",
      "tr": "Papua Yeni Gine"
    },
    "name": "Papua new Guinea",
    "native": "Papua Niugini",
    "phoneCode": "675",
    "region": "Oceania",
    "subregion": "Melanesia",
    "updatedAt": 1657792804853
  },
  {
    "capital": "Asuncion",
    "createdAt": 1604406818000,
    "currency": "PYG",
    "currencyCode": "PYG",
    "currencySymbol": "₲",
    "deleted": false,
    "emoji": "🇵🇾",
    "emojiString": "U+1F1F5 U+1F1FE",
    "id": "7d887f3b-fecb-4cd2-a390-b29dab4f0b6d",
    "iso2": "PY",
    "iso3": "PRY",
    "locationTranslations": {
      "de": "Paraguay",
      "en": "Paraguay",
      "fr": "Paraguay",
      "tr": "Paraguay"
    },
    "name": "Paraguay",
    "native": "Paraguay",
    "phoneCode": "595",
    "region": "Americas",
    "subregion": "South America",
    "updatedAt": 1657792804386
  },
  {
    "capital": "Lima",
    "createdAt": 1604406818000,
    "currency": "PEN",
    "currencyCode": "PEN",
    "currencySymbol": "S/.",
    "deleted": false,
    "emoji": "🇵🇪",
    "emojiString": "U+1F1F5 U+1F1EA",
    "id": "a34d13e1-dc6e-413f-8ccf-5eb4b29f437c",
    "iso2": "PE",
    "iso3": "PER",
    "locationTranslations": {
      "de": "Peru",
      "en": "Peru",
      "fr": "Pérou",
      "tr": "Peru"
    },
    "name": "Peru",
    "native": "Perú",
    "phoneCode": "51",
    "region": "Americas",
    "subregion": "South America",
    "updatedAt": 1657792803650
  },
  {
    "capital": "Adamstown",
    "createdAt": 1604406818000,
    "currency": "NZD",
    "currencyCode": "NZD",
    "currencySymbol": "NZ$",
    "deleted": false,
    "emoji": "🇵🇳",
    "emojiString": "U+1F1F5 U+1F1F3",
    "id": "0acbb078-09b8-4764-b6a8-a8b055ce657f",
    "iso2": "PN",
    "iso3": "PCN",
    "locationTranslations": {
      "de": "Pitcairn",
      "en": "Pitcairn Island",
      "fr": "Pitcairn",
      "tr": "Pitcairn Adaları"
    },
    "name": "Pitcairn Island",
    "native": "Pitcairn Islands",
    "phoneCode": "870",
    "region": "Oceania",
    "subregion": "Polynesia",
    "updatedAt": 1658414430437
  },
  {
    "capital": "Warsaw",
    "createdAt": 1604406818000,
    "currency": "PLN",
    "currencyCode": "PLN",
    "currencySymbol": "zł",
    "deleted": false,
    "emoji": "🇵🇱",
    "emojiString": "U+1F1F5 U+1F1F1",
    "id": "a65710ef-fc19-4dda-91fb-9e0db85a175f",
    "iso2": "PL",
    "iso3": "POL",
    "locationTranslations": {
      "de": "Polen",
      "en": "Poland",
      "fr": "Pologne",
      "tr": "Polonya"
    },
    "name": "Poland",
    "native": "Polska",
    "phoneCode": "48",
    "region": "Europe",
    "subregion": "Eastern Europe",
    "updatedAt": 1657792808830
  },
  {
    "capital": "Lisbon",
    "createdAt": 1604406818000,
    "currency": "EUR",
    "currencyCode": "EUR",
    "currencySymbol": "€",
    "deleted": false,
    "emoji": "🇵🇹",
    "emojiString": "U+1F1F5 U+1F1F9",
    "id": "86383278-b134-42ac-bdf5-3d85a9db426b",
    "iso2": "PT",
    "iso3": "PRT",
    "locationTranslations": {
      "de": "Portugal",
      "en": "Portugal",
      "fr": "Portugal",
      "tr": "Portekiz"
    },
    "name": "Portugal",
    "native": "Portugal",
    "phoneCode": "351",
    "region": "Europe",
    "subregion": "Southern Europe",
    "updatedAt": 1657792797487
  },
  {
    "capital": "San Juan",
    "createdAt": 1604406818000,
    "currency": "USD",
    "currencyCode": "USD",
    "currencySymbol": "$",
    "deleted": false,
    "emoji": "🇵🇷",
    "emojiString": "U+1F1F5 U+1F1F7",
    "id": "bbdd3309-611e-4d22-b4c5-0a68ffe9ece6",
    "iso2": "PR",
    "iso3": "PRI",
    "locationTranslations": {
      "de": "Puerto Rico",
      "en": "Puerto Rico",
      "fr": "Porto Rico",
      "tr": "Porto Riko"
    },
    "name": "Puerto Rico",
    "native": "Puerto Rico",
    "phoneCode": "+1-787 and 1-939",
    "region": "Americas",
    "subregion": "Caribbean",
    "updatedAt": 1658414431310
  },
  {
    "capital": "Saint-Denis",
    "createdAt": 1604406818000,
    "currency": "EUR",
    "currencyCode": "EUR",
    "currencySymbol": "€",
    "deleted": false,
    "emoji": "🇷🇪",
    "emojiString": "U+1F1F7 U+1F1EA",
    "id": "11bb9a72-7323-431e-9ac2-ae72ebdfbb00",
    "iso2": "RE",
    "iso3": "REU",
    "locationTranslations": {
      "de": "Réunion",
      "en": "Reunion",
      "fr": "Réunion",
      "tr": "Réunion"
    },
    "name": "Reunion",
    "native": "La Réunion",
    "phoneCode": "262",
    "region": "Africa",
    "subregion": "Eastern Africa",
    "updatedAt": 1658414430494
  },
  {
    "capital": "Bucharest",
    "createdAt": 1604406818000,
    "currency": "RON",
    "currencyCode": "RON",
    "currencySymbol": "L",
    "deleted": false,
    "emoji": "🇷🇴",
    "emojiString": "U+1F1F7 U+1F1F4",
    "id": "625f4fac-899c-42eb-be91-b71b279c9fa1",
    "iso2": "RO",
    "iso3": "ROU",
    "locationTranslations": {
      "de": "Rumänien",
      "en": "Romania",
      "fr": "Roumanie",
      "tr": "Romanya"
    },
    "name": "Romania",
    "native": "România",
    "phoneCode": "40",
    "region": "Europe",
    "subregion": "Eastern Europe",
    "updatedAt": 1657792805945
  },
  {
    "capital": "Kigali",
    "createdAt": 1604406818000,
    "currency": "RWF",
    "currencyCode": "RWF",
    "currencySymbol": "FRw",
    "deleted": false,
    "emoji": "🇷🇼",
    "emojiString": "U+1F1F7 U+1F1FC",
    "id": "913dd46d-e7ae-499e-92e0-3fc1299a1a4b",
    "iso2": "RW",
    "iso3": "RWA",
    "locationTranslations": {
      "de": "Ruanda",
      "en": "Rwanda",
      "fr": "Rwanda",
      "tr": "Ruanda"
    },
    "name": "Rwanda",
    "native": "Rwanda",
    "phoneCode": "250",
    "region": "Africa",
    "subregion": "Eastern Africa",
    "updatedAt": 1657792798452
  },
  {
    "capital": "Moscow",
    "createdAt": 1604406818000,
    "currency": "RUB",
    "currencyCode": "RUB",
    "currencySymbol": "₽",
    "deleted": false,
    "emoji": "🇷🇺",
    "emojiString": "U+1F1F7 U+1F1FA",
    "id": "da080744-db09-4f69-ba5e-7806197db1ba",
    "iso2": "RU",
    "iso3": "RUS",
    "locationTranslations": {
      "de": "Russland",
      "en": "Russia",
      "fr": "Fédération De Russie",
      "tr": "Rusya"
    },
    "name": "Russia",
    "native": "Россия",
    "phoneCode": "7",
    "region": "Europe",
    "subregion": "Eastern Europe",
    "updatedAt": 1657792807062
  },
  {
    "capital": "Gustavia",
    "createdAt": 1604406818000,
    "currency": "EUR",
    "currencyCode": "EUR",
    "currencySymbol": "€",
    "deleted": false,
    "emoji": "🇧🇱",
    "emojiString": "U+1F1E7 U+1F1F1",
    "id": "fbb92e5c-c3d2-4053-8feb-143fb109c673",
    "iso2": "BL",
    "iso3": "BLM",
    "locationTranslations": {
      "de": "St. Barthélemy",
      "en": "Saint-Barthelemy",
      "fr": "Saint-Barthélemy",
      "tr": "Saint Barthélemy"
    },
    "name": "Saint-Barthelemy",
    "native": "Saint-Barthélemy",
    "phoneCode": "590",
    "region": "Americas",
    "subregion": "Caribbean",
    "updatedAt": 1658414430960
  },
  {
    "capital": "Jamestown",
    "createdAt": 1604406818000,
    "currency": "SHP",
    "currencyCode": "SHP",
    "currencySymbol": "£",
    "deleted": false,
    "emoji": "🇸🇭",
    "emojiString": "U+1F1F8 U+1F1ED",
    "id": "7aa7927a-c367-4729-b1e8-21c35c6e0268",
    "iso2": "SH",
    "iso3": "SHN",
    "locationTranslations": {
      "de": "St. Helena",
      "en": "Saint Helena",
      "fr": "Sainte-Hélène",
      "tr": "Saint Helena"
    },
    "name": "Saint Helena",
    "native": "Saint Helena",
    "phoneCode": "290",
    "region": "Africa",
    "subregion": "Western Africa",
    "updatedAt": 1658414431836
  },
  {
    "capital": "Basseterre",
    "createdAt": 1604406818000,
    "currency": "XCD",
    "currencyCode": "XCD",
    "currencySymbol": "$",
    "deleted": false,
    "emoji": "🇰🇳",
    "emojiString": "U+1F1F0 U+1F1F3",
    "id": "21a63041-d113-40dd-b7b3-be4be4f89d51",
    "iso2": "KN",
    "iso3": "KNA",
    "locationTranslations": {
      "de": "St. Kitts und Nevis",
      "en": "Saint Kitts And Nevis",
      "fr": "Saint-Christophe-et-Niévès",
      "tr": "Saint Kitts ve Nevis"
    },
    "name": "Saint Kitts And Nevis",
    "native": "Saint Kitts and Nevis",
    "phoneCode": "+1-869",
    "region": "Americas",
    "subregion": "Caribbean",
    "updatedAt": 1657792797055
  },
  {
    "capital": "Castries",
    "createdAt": 1604406818000,
    "currency": "XCD",
    "currencyCode": "XCD",
    "currencySymbol": "$",
    "deleted": false,
    "emoji": "🇱🇨",
    "emojiString": "U+1F1F1 U+1F1E8",
    "id": "2ab6a213-2fbf-4161-acaa-8fd52a6c03c2",
    "iso2": "LC",
    "iso3": "LCA",
    "locationTranslations": {
      "de": "St. Lucia",
      "en": "Saint Lucia",
      "fr": "Sainte-Lucie",
      "tr": "Saint Lucia"
    },
    "name": "Saint Lucia",
    "native": "Saint Lucia",
    "phoneCode": "+1-758",
    "region": "Americas",
    "subregion": "Caribbean",
    "updatedAt": 1657792800018
  },
  {
    "capital": "Marigot",
    "createdAt": 1604406818000,
    "currency": "EUR",
    "currencyCode": "EUR",
    "currencySymbol": "€",
    "deleted": false,
    "emoji": "🇲🇫",
    "emojiString": "U+1F1F2 U+1F1EB",
    "id": "8ae31701-31cc-4c8a-8b6b-d37e5b925b3c",
    "iso2": "MF",
    "iso3": "MAF",
    "locationTranslations": {
      "de": "St. Martin",
      "en": "Saint-Martin (French part)",
      "fr": "Saint-Martin (Partie Française)",
      "tr": "Saint Martin"
    },
    "name": "Saint-Martin (French part)",
    "native": "Saint-Martin",
    "phoneCode": "590",
    "region": "Americas",
    "subregion": "Caribbean",
    "updatedAt": 1658414431779
  },
  {
    "capital": "Saint-Pierre",
    "createdAt": 1604406818000,
    "currency": "EUR",
    "currencyCode": "EUR",
    "currencySymbol": "€",
    "deleted": false,
    "emoji": "🇵🇲",
    "emojiString": "U+1F1F5 U+1F1F2",
    "id": "7dd27225-bb50-414d-ada1-0c22c1dd58f7",
    "iso2": "PM",
    "iso3": "SPM",
    "locationTranslations": {
      "de": "St. Pierre und Miquelon",
      "en": "Saint Pierre and Miquelon",
      "fr": "Saint-Pierre-Et-Miquelon",
      "tr": "Saint Pierre ve Miquelon"
    },
    "name": "Saint Pierre and Miquelon",
    "native": "Saint-Pierre-et-Miquelon",
    "phoneCode": "508",
    "region": "Americas",
    "subregion": "Northern America",
    "updatedAt": 1658414430320
  },
  {
    "capital": "Kingstown",
    "createdAt": 1604406818000,
    "currency": "XCD",
    "currencyCode": "XCD",
    "currencySymbol": "$",
    "deleted": false,
    "emoji": "🇻🇨",
    "emojiString": "U+1F1FB U+1F1E8",
    "id": "85c45452-f81d-457d-8961-8ea329822d51",
    "iso2": "VC",
    "iso3": "VCT",
    "locationTranslations": {
      "de": "St. Vincent und die Grenadinen",
      "en": "Saint Vincent And The Grenadines",
      "fr": "Saint-Vincent-Et-Les Grenadines",
      "tr": "Saint Vincent ve Grenadinler"
    },
    "name": "Saint Vincent And The Grenadines",
    "native": "Saint Vincent and the Grenadines",
    "phoneCode": "+1-784",
    "region": "Americas",
    "subregion": "Caribbean",
    "updatedAt": 1657792801887
  },
  {
    "capital": "Apia",
    "createdAt": 1604406818000,
    "currency": "WST",
    "currencyCode": "WST",
    "currencySymbol": "T",
    "deleted": false,
    "emoji": "🇼🇸",
    "emojiString": "U+1F1FC U+1F1F8",
    "id": "8b03e37b-b895-47fb-b531-e593cf19b9e7",
    "iso2": "WS",
    "iso3": "WSM",
    "locationTranslations": {
      "de": "Samoa",
      "en": "Samoa",
      "fr": "Samoa",
      "tr": "Samoa"
    },
    "name": "Samoa",
    "native": "Samoa",
    "phoneCode": "685",
    "region": "Oceania",
    "subregion": "Polynesia",
    "updatedAt": 1657792802778
  },
  {
    "capital": "San Marino",
    "createdAt": 1604406818000,
    "currency": "EUR",
    "currencyCode": "EUR",
    "currencySymbol": "€",
    "deleted": false,
    "emoji": "🇸🇲",
    "emojiString": "U+1F1F8 U+1F1F2",
    "id": "81c62a98-447b-4e98-831a-8f0d5eabf884",
    "iso2": "SM",
    "iso3": "SMR",
    "locationTranslations": {
      "de": "San Marino",
      "en": "San Marino",
      "fr": "Saint-Marin",
      "tr": "San Marino"
    },
    "name": "San Marino",
    "native": "San Marino",
    "phoneCode": "378",
    "region": "Europe",
    "subregion": "Southern Europe",
    "updatedAt": 1657792806882
  },
  {
    "capital": "Sao Tome",
    "createdAt": 1604406818000,
    "currency": "STD",
    "currencyCode": "STD",
    "currencySymbol": "Db",
    "deleted": false,
    "emoji": "🇸🇹",
    "emojiString": "U+1F1F8 U+1F1F9",
    "id": "3ea0c8fd-1c02-4f16-978c-cd1c63742ac7",
    "iso2": "ST",
    "iso3": "STP",
    "locationTranslations": {
      "de": "São Tomé und Príncipe",
      "en": "Sao Tome and Principe",
      "fr": "Sao Tomé-Et-Principe",
      "tr": "Sao Tome ve Principe"
    },
    "name": "Sao Tome and Principe",
    "native": "São Tomé e Príncipe",
    "phoneCode": "239",
    "region": "Africa",
    "subregion": "Middle Africa",
    "updatedAt": 1657792803044
  },
  {
    "capital": "Dakar",
    "createdAt": 1604406818000,
    "currency": "XOF",
    "currencyCode": "XOF",
    "currencySymbol": "₣",
    "deleted": false,
    "emoji": "🇸🇳",
    "emojiString": "U+1F1F8 U+1F1F3",
    "id": "2e755731-df87-4c8d-a965-f65c9845efc4",
    "iso2": "SN",
    "iso3": "SEN",
    "locationTranslations": {
      "de": "Senegal",
      "en": "Senegal",
      "fr": "Sénégal",
      "tr": "Senegal"
    },
    "name": "Senegal",
    "native": "Sénégal",
    "phoneCode": "221",
    "region": "Africa",
    "subregion": "Western Africa",
    "updatedAt": 1657792802242
  },
  {
    "capital": "Victoria",
    "createdAt": 1604406818000,
    "currency": "SCR",
    "currencyCode": "SCR",
    "currencySymbol": "Rs.",
    "deleted": false,
    "emoji": "🇸🇨",
    "emojiString": "U+1F1F8 U+1F1E8",
    "id": "f3daf782-7051-46bd-8b4f-08b2bd990ccf",
    "iso2": "SC",
    "iso3": "SYC",
    "locationTranslations": {
      "de": "Seychellen",
      "en": "Seychelles",
      "fr": "Seychelles",
      "tr": "Seyşeller"
    },
    "name": "Seychelles",
    "native": "Seychelles",
    "phoneCode": "248",
    "region": "Africa",
    "subregion": "Eastern Africa",
    "updatedAt": 1657792806198
  },
  {
    "capital": "Belgrade",
    "createdAt": 1604406818000,
    "currency": "RSD",
    "currencyCode": "RSD",
    "currencySymbol": "din",
    "deleted": false,
    "emoji": "🇷🇸",
    "emojiString": "U+1F1F7 U+1F1F8",
    "id": "ae5a15cd-e306-4b5e-b101-0ffe5eb7f41f",
    "iso2": "RS",
    "iso3": "SRB",
    "locationTranslations": {
      "de": "Serbien",
      "en": "Serbia",
      "fr": "Serbie",
      "tr": "Sırbistan"
    },
    "name": "Serbia",
    "native": "Србија",
    "phoneCode": "381",
    "region": "Europe",
    "subregion": "Southern Europe",
    "updatedAt": 1657792805216
  },
  {
    "capital": "Freetown",
    "createdAt": 1604406818000,
    "currency": "SLL",
    "currencyCode": "SLL",
    "currencySymbol": "Le",
    "deleted": false,
    "emoji": "🇸🇱",
    "emojiString": "U+1F1F8 U+1F1F1",
    "id": "60c8a807-1e04-4563-8603-586eb2a2b6a0",
    "iso2": "SL",
    "iso3": "SLE",
    "locationTranslations": {
      "de": "Sierra Leone",
      "en": "Sierra Leone",
      "fr": "Sierra Leone",
      "tr": "Sierra Leone"
    },
    "name": "Sierra Leone",
    "native": "Sierra Leone",
    "phoneCode": "232",
    "region": "Africa",
    "subregion": "Western Africa",
    "updatedAt": 1657792803828
  },
  {
    "capital": "Singapur",
    "createdAt": 1604406818000,
    "currency": "SGD",
    "currencyCode": "SGD",
    "currencySymbol": "S$",
    "deleted": false,
    "emoji": "🇸🇬",
    "emojiString": "U+1F1F8 U+1F1EC",
    "id": "29d15422-8fd8-4a52-b7b3-41ea8a4af40c",
    "iso2": "SG",
    "iso3": "SGP",
    "locationTranslations": {
      "de": "Singapur",
      "en": "Singapore",
      "fr": "Singapour",
      "tr": "Singapur"
    },
    "name": "Singapore",
    "native": "Singapore",
    "phoneCode": "65",
    "region": "Asia",
    "subregion": "South-Eastern Asia",
    "updatedAt": 1657792807407
  },
  {
    "capital": "Bratislava",
    "createdAt": 1604406818000,
    "currency": "EUR",
    "currencyCode": "EUR",
    "currencySymbol": "€",
    "deleted": false,
    "emoji": "🇸🇰",
    "emojiString": "U+1F1F8 U+1F1F0",
    "id": "479f3642-8e45-4829-b7e0-df2238f6e900",
    "iso2": "SK",
    "iso3": "SVK",
    "locationTranslations": {
      "de": "Slowakei",
      "en": "Slovakia",
      "fr": "Slovaquie",
      "tr": "Slovakya"
    },
    "name": "Slovakia",
    "native": "Slovensko",
    "phoneCode": "421",
    "region": "Europe",
    "subregion": "Eastern Europe",
    "updatedAt": 1657792806292
  },
  {
    "capital": "Ljubljana",
    "createdAt": 1604406818000,
    "currency": "EUR",
    "currencyCode": "EUR",
    "currencySymbol": "€",
    "deleted": false,
    "emoji": "🇸🇮",
    "emojiString": "U+1F1F8 U+1F1EE",
    "id": "d0cce2e6-32e3-4577-93b4-178bbcd45e3a",
    "iso2": "SI",
    "iso3": "SVN",
    "locationTranslations": {
      "de": "Slowenien",
      "en": "Slovenia",
      "fr": "Slovénie",
      "tr": "Slovenya"
    },
    "name": "Slovenia",
    "native": "Slovenija",
    "phoneCode": "386",
    "region": "Europe",
    "subregion": "Southern Europe",
    "updatedAt": 1657792809712
  },
  {
    "capital": "Honiara",
    "createdAt": 1604406818000,
    "currency": "SBD",
    "currencyCode": "SBD",
    "currencySymbol": "SI$",
    "deleted": false,
    "emoji": "🇸🇧",
    "emojiString": "U+1F1F8 U+1F1E7",
    "id": "266c5da8-9ebf-4fe2-b60c-47a3da5b0b43",
    "iso2": "SB",
    "iso3": "SLB",
    "locationTranslations": {
      "de": "Salomonen",
      "en": "Solomon Islands",
      "fr": "Îles Salomon",
      "tr": "Solomon Adaları"
    },
    "name": "Solomon Islands",
    "native": "Solomon Islands",
    "phoneCode": "677",
    "region": "Oceania",
    "subregion": "Melanesia",
    "updatedAt": 1657792808985
  },
  {
    "capital": "Mogadishu",
    "createdAt": 1604406818000,
    "currency": "SOS",
    "currencyCode": "SOS",
    "currencySymbol": "Sh.So.",
    "deleted": false,
    "emoji": "🇸🇴",
    "emojiString": "U+1F1F8 U+1F1F4",
    "id": "88595542-dbe5-4e89-9445-7e6bb94ee237",
    "iso2": "SO",
    "iso3": "SOM",
    "locationTranslations": {
      "de": "Somalia",
      "en": "Somalia",
      "fr": "Somalie",
      "tr": "Somali"
    },
    "name": "Somalia",
    "native": "Soomaaliya",
    "phoneCode": "252",
    "region": "Africa",
    "subregion": "Eastern Africa",
    "updatedAt": 1657792809522
  },
  {
    "capital": "Colombo",
    "createdAt": 1604406818001,
    "currency": "LKR",
    "currencyCode": "LKR",
    "currencySymbol": "Rs.",
    "deleted": false,
    "emoji": "🇱🇰",
    "emojiString": "U+1F1F1 U+1F1F0",
    "id": "55b84d99-dfb5-4dab-aad2-5cda97e25d22",
    "iso2": "LK",
    "iso3": "LKA",
    "locationTranslations": {
      "de": "Sri Lanka",
      "en": "Sri Lanka",
      "fr": "Sri Lanka",
      "tr": "Sri Lanka"
    },
    "name": "Sri Lanka",
    "native": "śrī laṃkāva",
    "phoneCode": "94",
    "region": "Asia",
    "subregion": "Southern Asia",
    "updatedAt": 1657792808490
  },
  {
    "capital": "Khartoum",
    "createdAt": 1604406818001,
    "currency": "SDG",
    "currencyCode": "SDG",
    "currencySymbol": "£SD",
    "deleted": false,
    "emoji": "🇸🇩",
    "emojiString": "U+1F1F8 U+1F1E9",
    "id": "9e4a8d6d-8ec7-419f-aba9-c584321a56c6",
    "iso2": "SD",
    "iso3": "SDN",
    "locationTranslations": {
      "de": "Sudan",
      "en": "Sudan",
      "fr": "Soudan",
      "tr": "Sudan"
    },
    "name": "Sudan",
    "native": "السودان",
    "phoneCode": "249",
    "region": "Africa",
    "subregion": "Northern Africa",
    "updatedAt": 1657792805865
  },
  {
    "capital": "Paramaribo",
    "createdAt": 1604406818001,
    "currency": "SRD",
    "currencyCode": "SRD",
    "currencySymbol": "Sr$",
    "deleted": false,
    "emoji": "🇸🇷",
    "emojiString": "U+1F1F8 U+1F1F7",
    "id": "d3fa06cb-3147-4770-9308-901e3a365791",
    "iso2": "SR",
    "iso3": "SUR",
    "locationTranslations": {
      "de": "Suriname",
      "en": "Suriname",
      "fr": "Suriname",
      "tr": "Surinam"
    },
    "name": "Suriname",
    "native": "Suriname",
    "phoneCode": "597",
    "region": "Americas",
    "subregion": "South America",
    "updatedAt": 1657792808583
  },
  {
    "capital": "Damascus",
    "createdAt": 1604406818002,
    "currency": "SYP",
    "currencyCode": "SYP",
    "currencySymbol": "LS",
    "deleted": false,
    "emoji": "🇸🇾",
    "emojiString": "U+1F1F8 U+1F1FE",
    "id": "b3d2299b-f22e-446e-a505-8970ff933999",
    "iso2": "SY",
    "iso3": "SYR",
    "locationTranslations": {
      "de": "Syrien",
      "en": "Syria",
      "fr": "République Arabe Syrienne",
      "tr": "Suriye"
    },
    "name": "Syria",
    "native": "سوريا",
    "phoneCode": "963",
    "region": "Asia",
    "subregion": "Western Asia",
    "updatedAt": 1657792805129
  },
  {
    "capital": "Riyadh",
    "createdAt": 1604406818000,
    "currency": "SAR",
    "currencyCode": "SAR",
    "currencySymbol": "SR",
    "deleted": false,
    "emoji": "🇸🇦",
    "emojiString": "U+1F1F8 U+1F1E6",
    "id": "e10bc1c0-6b97-41f8-a616-c56ee02cb444",
    "iso2": "SA",
    "iso3": "SAU",
    "locationTranslations": {
      "de": "Saudi-Arabien",
      "en": "Saudi Arabia",
      "fr": "Arabie Saoudite",
      "tr": "Suudi Arabistan"
    },
    "name": "Saudi Arabia",
    "native": "العربية السعودية",
    "phoneCode": "966",
    "region": "Asia",
    "subregion": "Western Asia",
    "updatedAt": 1657792802863
  },
  {
    "capital": "Longyearbyen",
    "createdAt": 1604406818001,
    "currency": "NOK",
    "currencyCode": "NOK",
    "currencySymbol": "kr",
    "deleted": false,
    "emoji": "🇸🇯",
    "emojiString": "U+1F1F8 U+1F1EF",
    "id": "047d5c34-4802-4a93-9cd4-a3f871bff182",
    "iso2": "SJ",
    "iso3": "SJM",
    "locationTranslations": {
      "de": "Svalbard und Jan Mayen",
      "en": "Svalbard And Jan Mayen Islands",
      "fr": "Svalbard Et Jan Mayen",
      "tr": "Svalbard ve Jan Mayen"
    },
    "name": "Svalbard And Jan Mayen Islands",
    "native": "Svalbard og Jan Mayen",
    "phoneCode": "47",
    "region": "Europe",
    "subregion": "Northern Europe",
    "updatedAt": 1658414431721
  },
  {
    "capital": "Mbabane",
    "createdAt": 1604406818001,
    "currency": "SZL",
    "currencyCode": "SZL",
    "currencySymbol": "L",
    "deleted": false,
    "emoji": "🇸🇿",
    "emojiString": "U+1F1F8 U+1F1FF",
    "id": "e19ad285-8c23-4768-9bd3-cb9716a00f8c",
    "iso2": "SZ",
    "iso3": "SWZ",
    "locationTranslations": {
      "de": "Eswatini",
      "en": "Swaziland",
      "fr": "Swaziland",
      "tr": "Swaziland"
    },
    "name": "Swaziland",
    "native": "Swaziland",
    "phoneCode": "268",
    "region": "Africa",
    "subregion": "Southern Africa",
    "updatedAt": 1657792801989
  },
  {
    "capital": "Santiago",
    "createdAt": 1604406817997,
    "currency": "CLP",
    "currencyCode": "CLP",
    "currencySymbol": "CL$",
    "deleted": false,
    "emoji": "🇨🇱",
    "emojiString": "U+1F1E8 U+1F1F1",
    "id": "f4b8bae2-e686-4ff7-969a-8bbcb194fa75",
    "iso2": "CL",
    "iso3": "CHL",
    "locationTranslations": {
      "de": "Chile",
      "en": "Chile",
      "fr": "Chili",
      "tr": "Şili"
    },
    "name": "Chile",
    "native": "Chile",
    "phoneCode": "56",
    "region": "Americas",
    "subregion": "South America",
    "updatedAt": 1657792795889
  },
  {
    "capital": "Dushanbe",
    "createdAt": 1604406818002,
    "currency": "TJS",
    "currencyCode": "TJS",
    "currencySymbol": "SM",
    "deleted": false,
    "emoji": "🇹🇯",
    "emojiString": "U+1F1F9 U+1F1EF",
    "id": "a92925b1-769f-4f6c-bba3-d3aaa73b9ab9",
    "iso2": "TJ",
    "iso3": "TJK",
    "locationTranslations": {
      "de": "Tadschikistan",
      "en": "Tajikistan",
      "fr": "Tadjikistan",
      "tr": "Tacikistan"
    },
    "name": "Tajikistan",
    "native": "Тоҷикистон",
    "phoneCode": "992",
    "region": "Asia",
    "subregion": "Central Asia",
    "updatedAt": 1657792809152
  },
  {
    "capital": "Dodoma",
    "createdAt": 1604406818002,
    "currency": "TZS",
    "currencyCode": "TZS",
    "currencySymbol": "TSh",
    "deleted": false,
    "emoji": "🇹🇿",
    "emojiString": "U+1F1F9 U+1F1FF",
    "id": "1f0e6d92-cbb4-4c7c-aa60-e934ff469a72",
    "iso2": "TZ",
    "iso3": "TZA",
    "locationTranslations": {
      "de": "Tansania",
      "en": "Tanzania",
      "fr": "République-Unie De Tanzanie",
      "tr": "Tanzanya"
    },
    "name": "Tanzania",
    "native": "Tanzania",
    "phoneCode": "255",
    "region": "Africa",
    "subregion": "Eastern Africa",
    "updatedAt": 1657792806023
  },
  {
    "capital": "Bangkok",
    "createdAt": 1604406818002,
    "currency": "THB",
    "currencyCode": "THB",
    "currencySymbol": "฿",
    "deleted": false,
    "emoji": "🇹🇭",
    "emojiString": "U+1F1F9 U+1F1ED",
    "id": "547d577c-caf0-448a-a991-10ca7ccf472d",
    "iso2": "TH",
    "iso3": "THA",
    "locationTranslations": {
      "de": "Thailand",
      "en": "Thailand",
      "fr": "Thaïlande",
      "tr": "Tayland"
    },
    "name": "Thailand",
    "native": "ประเทศไทย",
    "phoneCode": "66",
    "region": "Asia",
    "subregion": "South-Eastern Asia",
    "updatedAt": 1657792807323
  },
  {
    "capital": "Taipei",
    "createdAt": 1604406818002,
    "currency": "TWD",
    "currencyCode": "TWD",
    "currencySymbol": "NT$",
    "deleted": false,
    "emoji": "🇹🇼",
    "emojiString": "U+1F1F9 U+1F1FC",
    "id": "bd8301f7-2d92-4252-8411-91ef80883810",
    "iso2": "TW",
    "iso3": "TWN",
    "locationTranslations": {
      "de": "Taiwan",
      "en": "Taiwan",
      "fr": "Taïwan",
      "tr": "Tayvan"
    },
    "name": "Taiwan",
    "native": "臺灣",
    "phoneCode": "886",
    "region": "Asia",
    "subregion": "Eastern Asia",
    "updatedAt": 1658414432709
  },
  {
    "capital": "Lome",
    "createdAt": 1604406818002,
    "currency": "XOF",
    "currencyCode": "XOF",
    "currencySymbol": "₣",
    "deleted": false,
    "emoji": "🇹🇬",
    "emojiString": "U+1F1F9 U+1F1EC",
    "id": "8198871b-f706-4db2-ad10-2246300a2d18",
    "iso2": "TG",
    "iso3": "TGO",
    "locationTranslations": {
      "de": "Togo",
      "en": "Togo",
      "fr": "Togo",
      "tr": "Togo"
    },
    "name": "Togo",
    "native": "Togo",
    "phoneCode": "228",
    "region": "Africa",
    "subregion": "Western Africa",
    "updatedAt": 1657792804584
  },
  {
    "capital": "",
    "createdAt": 1604406818002,
    "currency": "NZD",
    "currencyCode": "NZD",
    "currencySymbol": "NZ$",
    "deleted": false,
    "emoji": "🇹🇰",
    "emojiString": "U+1F1F9 U+1F1F0",
    "id": "16fc1bcf-82f0-4f21-93cf-e3b279c3e137",
    "iso2": "TK",
    "iso3": "TKL",
    "locationTranslations": {
      "de": "Tokelau",
      "en": "Tokelau",
      "fr": "Tokelau",
      "tr": "Tokelau"
    },
    "name": "Tokelau",
    "native": "Tokelau",
    "phoneCode": "690",
    "region": "Oceania",
    "subregion": "Polynesia",
    "updatedAt": 1658414431663
  },
  {
    "capital": "Nuku'alofa",
    "createdAt": 1604406818002,
    "currency": "TOP",
    "currencyCode": "TOP",
    "currencySymbol": "T$",
    "deleted": false,
    "emoji": "🇹🇴",
    "emojiString": "U+1F1F9 U+1F1F4",
    "id": "c35ff407-62ec-4f8c-87f3-eb66eb34af14",
    "iso2": "TO",
    "iso3": "TON",
    "locationTranslations": {
      "de": "Tonga",
      "en": "Tonga",
      "fr": "Tonga",
      "tr": "Tonga"
    },
    "name": "Tonga",
    "native": "Tonga",
    "phoneCode": "676",
    "region": "Oceania",
    "subregion": "Polynesia",
    "updatedAt": 1657792803909
  },
  {
    "capital": "Port of Spain",
    "createdAt": 1604406818002,
    "currency": "TTD",
    "currencyCode": "TTD",
    "currencySymbol": "TT$",
    "deleted": false,
    "emoji": "🇹🇹",
    "emojiString": "U+1F1F9 U+1F1F9",
    "id": "14409926-d43f-49ed-b622-a60b2a64e64e",
    "iso2": "TT",
    "iso3": "TTO",
    "locationTranslations": {
      "de": "Trinidad und Tobago",
      "en": "Trinidad And Tobago",
      "fr": "Trinité-Et-Tobago",
      "tr": "Trinidad ve Tobago"
    },
    "name": "Trinidad And Tobago",
    "native": "Trinidad and Tobago",
    "phoneCode": "+1-868",
    "region": "Americas",
    "subregion": "Caribbean",
    "updatedAt": 1657792804492
  },
  {
    "capital": "Tunis",
    "createdAt": 1604406818002,
    "currency": "TND",
    "currencyCode": "TND",
    "currencySymbol": "DT",
    "deleted": false,
    "emoji": "🇹🇳",
    "emojiString": "U+1F1F9 U+1F1F3",
    "id": "b12819cf-e856-494f-8861-ffb8b5f9a244",
    "iso2": "TN",
    "iso3": "TUN",
    "locationTranslations": {
      "de": "Tunesien",
      "en": "Tunisia",
      "fr": "Tunisie",
      "tr": "Tunus"
    },
    "name": "Tunisia",
    "native": "تونس",
    "phoneCode": "216",
    "region": "Africa",
    "subregion": "Northern Africa",
    "updatedAt": 1657792805404
  },
  {
    "capital": "Cockburn Town",
    "createdAt": 1604406818002,
    "currency": "USD",
    "currencyCode": "USD",
    "currencySymbol": "$",
    "deleted": false,
    "emoji": "🇹🇨",
    "emojiString": "U+1F1F9 U+1F1E8",
    "id": "8a7e2b88-aa81-42f2-b2a7-dd70d8c6cde9",
    "iso2": "TC",
    "iso3": "TCA",
    "locationTranslations": {
      "de": "Turks- und Caicosinseln",
      "en": "Turks And Caicos Islands",
      "fr": "Îles Turks-Et-Caïcos",
      "tr": "Turks ve Caicos Adaları"
    },
    "name": "Turks And Caicos Islands",
    "native": "Turks and Caicos Islands",
    "phoneCode": "+1-649",
    "region": "Americas",
    "subregion": "Caribbean",
    "updatedAt": 1658414431896
  },
  {
    "capital": "Funafuti",
    "createdAt": 1604406818002,
    "currency": "AUD",
    "currencyCode": "AUD",
    "currencySymbol": "AU$",
    "deleted": false,
    "emoji": "🇹🇻",
    "emojiString": "U+1F1F9 U+1F1FB",
    "id": "521bca3a-8c41-4581-ba5e-63e82bc37d81",
    "iso2": "TV",
    "iso3": "TUV",
    "locationTranslations": {
      "de": "Tuvalu",
      "en": "Tuvalu",
      "fr": "Tuvalu",
      "tr": "Tuvalu"
    },
    "name": "Tuvalu",
    "native": "Tuvalu",
    "phoneCode": "688",
    "region": "Oceania",
    "subregion": "Polynesia",
    "updatedAt": 1657792803131
  },
  {
    "capital": "Ankara",
    "createdAt": 1604408508236,
    "currency": "TRY",
    "currencyCode": "TRY",
    "currencySymbol": "₺",
    "deleted": false,
    "emoji": "🇹🇷",
    "emojiString": "U+1F1F9 U+1F1F7",
    "id": "da8c5f2a-8d37-48a8-beff-6ab3793a1861",
    "iso2": "TR",
    "iso3": "TUR",
    "locationTranslations": {
      "de": "Türkei",
      "en": "Turkey",
      "fr": "Turquie",
      "tr": "Türkiye"
    },
    "name": "Turkey",
    "native": "Türkiye",
    "phoneCode": "90",
    "region": "Asia",
    "subregion": "Western Asia",
    "updatedAt": 1657792809361
  },
  {
    "capital": "Ashgabat",
    "createdAt": 1604406818002,
    "currency": "TMT",
    "currencyCode": "TMT",
    "currencySymbol": "m.",
    "deleted": false,
    "emoji": "🇹🇲",
    "emojiString": "U+1F1F9 U+1F1F2",
    "id": "4d6ecb0d-5cea-4718-b252-ce15b6d4dd80",
    "iso2": "TM",
    "iso3": "TKM",
    "locationTranslations": {
      "de": "Turkmenistan",
      "en": "Turkmenistan",
      "fr": "Turkménistan",
      "tr": "Türkmenistan"
    },
    "name": "Turkmenistan",
    "native": "Türkmenistan",
    "phoneCode": "993",
    "region": "Asia",
    "subregion": "Central Asia",
    "updatedAt": 1657792805754
  },
  {
    "capital": "Kampala",
    "createdAt": 1604406818002,
    "currency": "UGX",
    "currencyCode": "UGX",
    "currencySymbol": "USh",
    "deleted": false,
    "emoji": "🇺🇬",
    "emojiString": "U+1F1FA U+1F1EC",
    "id": "a9e77669-1599-438b-aabf-988f2c393e85",
    "iso2": "UG",
    "iso3": "UGA",
    "locationTranslations": {
      "de": "Uganda",
      "en": "Uganda",
      "fr": "Ouganda",
      "tr": "Uganda"
    },
    "name": "Uganda",
    "native": "Uganda",
    "phoneCode": "256",
    "region": "Africa",
    "subregion": "Eastern Africa",
    "updatedAt": 1657792808661
  },
  {
    "capital": "Kiev",
    "createdAt": 1604406818002,
    "currency": "UAH",
    "currencyCode": "UAH",
    "currencySymbol": "₴",
    "deleted": false,
    "emoji": "🇺🇦",
    "emojiString": "U+1F1FA U+1F1E6",
    "id": "c1e1668d-e425-4cde-a553-8f0ddea30a72",
    "iso2": "UA",
    "iso3": "UKR",
    "locationTranslations": {
      "de": "Ukraine",
      "en": "Ukraine",
      "fr": "Ukraine",
      "tr": "Ukrayna"
    },
    "name": "Ukraine",
    "native": "Україна",
    "phoneCode": "380",
    "region": "Europe",
    "subregion": "Eastern Europe",
    "updatedAt": 1657792809063
  },
  {
    "capital": "Muscat",
    "createdAt": 1604406817999,
    "currency": "OMR",
    "currencyCode": "OMR",
    "currencySymbol": "OR",
    "deleted": false,
    "emoji": "🇴🇲",
    "emojiString": "U+1F1F4 U+1F1F2",
    "id": "0e25fb91-9895-4e7e-8e89-7360a294c8f9",
    "iso2": "OM",
    "iso3": "OMN",
    "locationTranslations": {
      "de": "Oman",
      "en": "Oman",
      "fr": "Oman",
      "tr": "Umman"
    },
    "name": "Oman",
    "native": "عمان",
    "phoneCode": "968",
    "region": "Asia",
    "subregion": "Western Asia",
    "updatedAt": 1657792797311
  },
  {
    "capital": "Montevideo",
    "createdAt": 1604406818002,
    "currency": "UYU",
    "currencyCode": "UYU",
    "currencySymbol": "$U",
    "deleted": false,
    "emoji": "🇺🇾",
    "emojiString": "U+1F1FA U+1F1FE",
    "id": "ce6cab29-a3a0-404d-b06a-6ff6846287df",
    "iso2": "UY",
    "iso3": "URY",
    "locationTranslations": {
      "de": "Uruguay",
      "en": "Uruguay",
      "fr": "Uruguay",
      "tr": "Uruguay"
    },
    "name": "Uruguay",
    "native": "Uruguay",
    "phoneCode": "598",
    "region": "Americas",
    "subregion": "South America",
    "updatedAt": 1657792807871
  },
  {
    "capital": "Amman",
    "createdAt": 1604406817998,
    "currency": "JOD",
    "currencyCode": "JOD",
    "currencySymbol": "JD",
    "deleted": false,
    "emoji": "🇯🇴",
    "emojiString": "U+1F1EF U+1F1F4",
    "id": "60ffbb7b-13c0-4ea8-8108-5df2ac928dd4",
    "iso2": "JO",
    "iso3": "JOR",
    "locationTranslations": {
      "de": "Jordanien",
      "en": "Jordan",
      "fr": "Jordanie",
      "tr": "Ürdün"
    },
    "name": "Jordan",
    "native": "الأردن",
    "phoneCode": "962",
    "region": "Asia",
    "subregion": "Western Asia",
    "updatedAt": 1657792798806
  },
  {
    "capital": "Port Vila",
    "createdAt": 1604406818002,
    "currency": "VUV",
    "currencyCode": "VUV",
    "currencySymbol": "VT",
    "deleted": false,
    "emoji": "🇻🇺",
    "emojiString": "U+1F1FB U+1F1FA",
    "id": "2daa62ee-b22c-409c-b71e-fc84feeb0803",
    "iso2": "VU",
    "iso3": "VUT",
    "locationTranslations": {
      "de": "Vanuatu",
      "en": "Vanuatu",
      "fr": "Vanuatu",
      "tr": "Vanuatu"
    },
    "name": "Vanuatu",
    "native": "Vanuatu",
    "phoneCode": "678",
    "region": "Oceania",
    "subregion": "Melanesia",
    "updatedAt": 1657792809250
  },
  {
    "capital": "Vatican City",
    "createdAt": 1604406818002,
    "currency": "EUR",
    "currencyCode": "EUR",
    "currencySymbol": "€",
    "deleted": false,
    "emoji": "🇻🇦",
    "emojiString": "U+1F1FB U+1F1E6",
    "id": "2543e9f6-45c3-430f-bd1c-7be97fcb0f40",
    "iso2": "VA",
    "iso3": "VAT",
    "locationTranslations": {
      "de": "Vatikanstadt",
      "en": "Vatican City",
      "fr": "Saint-Siège (État De La Cité Du Vatican)",
      "tr": "Vatikan"
    },
    "name": "Vatican City",
    "native": "Vaticano",
    "phoneCode": "379",
    "region": "Europe",
    "subregion": "Southern Europe",
    "updatedAt": 1658414432537
  },
  {
    "capital": "Caracas",
    "createdAt": 1604406818002,
    "currency": "VEF",
    "currencyCode": "VEF",
    "currencySymbol": "VEF",
    "deleted": false,
    "emoji": "🇻🇪",
    "emojiString": "U+1F1FB U+1F1EA",
    "id": "91f960f7-352a-4b0b-bda5-91560bb8b686",
    "iso2": "VE",
    "iso3": "VEN",
    "locationTranslations": {
      "de": "Venezuela",
      "en": "Venezuela",
      "fr": "Venezuela",
      "tr": "Venezuela"
    },
    "name": "Venezuela",
    "native": "Venezuela",
    "phoneCode": "58",
    "region": "Americas",
    "subregion": "South America",
    "updatedAt": 1657792809804
  },
  {
    "capital": "Hanoi",
    "createdAt": 1604406818002,
    "currency": "VND",
    "currencyCode": "VND",
    "currencySymbol": "₫",
    "deleted": false,
    "emoji": "🇻🇳",
    "emojiString": "U+1F1FB U+1F1F3",
    "id": "be85f778-65d0-48e3-9bb3-eb35cc260f5b",
    "iso2": "VN",
    "iso3": "VNM",
    "locationTranslations": {
      "de": "Vietnam",
      "en": "Vietnam",
      "fr": "Viet Nam",
      "tr": "Vietnam"
    },
    "name": "Vietnam",
    "native": "Việt Nam",
    "phoneCode": "84",
    "region": "Asia",
    "subregion": "South-Eastern Asia",
    "updatedAt": 1657792806794
  },
  {
    "capital": "Mata Utu",
    "createdAt": 1604406818002,
    "currency": "XPF",
    "currencyCode": "XPF",
    "currencySymbol": "₣",
    "deleted": false,
    "emoji": "🇼🇫",
    "emojiString": "U+1F1FC U+1F1EB",
    "id": "1bd2d8d9-6218-4bf2-b647-02b93fb2025c",
    "iso2": "WF",
    "iso3": "WLF",
    "locationTranslations": {
      "de": "Wallis und Futuna",
      "en": "Wallis And Futuna Islands",
      "fr": "Wallis Et Futuna",
      "tr": "Wallis ve Futuna"
    },
    "name": "Wallis And Futuna Islands",
    "native": "Wallis et Futuna",
    "phoneCode": "681",
    "region": "Oceania",
    "subregion": "Polynesia",
    "updatedAt": 1658414432013
  },
  {
    "capital": "Sanaa",
    "createdAt": 1604406818002,
    "currency": "YER",
    "currencyCode": "YER",
    "currencySymbol": "YR",
    "deleted": false,
    "emoji": "🇾🇪",
    "emojiString": "U+1F1FE U+1F1EA",
    "id": "0f5ac848-9bb1-4573-b279-ce622667bec5",
    "iso2": "YE",
    "iso3": "YEM",
    "locationTranslations": {
      "de": "Jemen",
      "en": "Yemen",
      "fr": "Yémen",
      "tr": "Yemen"
    },
    "name": "Yemen",
    "native": "اليَمَن",
    "phoneCode": "967",
    "region": "Asia",
    "subregion": "Western Asia",
    "updatedAt": 1657792802336
  },
  {
    "capital": "Noumea",
    "createdAt": 1604406817999,
    "currency": "XPF",
    "currencyCode": "XPF",
    "currencySymbol": "₣",
    "deleted": false,
    "emoji": "🇳🇨",
    "emojiString": "U+1F1F3 U+1F1E8",
    "id": "f1b496bc-8dc8-4100-925f-962a0cd84d7d",
    "iso2": "NC",
    "iso3": "NCL",
    "locationTranslations": {
      "de": "Neukaledonien",
      "en": "New Caledonia",
      "fr": "Nouvelle-Calédonie",
      "tr": "Yeni Kaledonya"
    },
    "name": "New Caledonia",
    "native": "Nouvelle-Calédonie",
    "phoneCode": "687",
    "region": "Oceania",
    "subregion": "Melanesia",
    "updatedAt": 1658414431193
  },
  {
    "capital": "Wellington",
    "createdAt": 1604406817999,
    "currency": "NZD",
    "currencyCode": "NZD",
    "currencySymbol": "NZ$",
    "deleted": false,
    "emoji": "🇳🇿",
    "emojiString": "U+1F1F3 U+1F1FF",
    "id": "5039f6f7-14c3-42ad-b9cd-f9936806dddb",
    "iso2": "NZ",
    "iso3": "NZL",
    "locationTranslations": {
      "de": "Neuseeland",
      "en": "New Zealand",
      "fr": "Nouvelle-Zélande",
      "tr": "Yeni Zelanda"
    },
    "name": "New Zealand",
    "native": "New Zealand",
    "phoneCode": "64",
    "region": "Oceania",
    "subregion": "Australia and New Zealand",
    "updatedAt": 1657792800976
  },
  {
    "capital": "Praia",
    "createdAt": 1604406817996,
    "currency": "CVE",
    "currencyCode": "CVE",
    "currencySymbol": "CV$",
    "deleted": false,
    "emoji": "🇨🇻",
    "emojiString": "U+1F1E8 U+1F1FB",
    "id": "a2ce98ca-2ba3-488a-b034-14e4b0cf84f2",
    "iso2": "CV",
    "iso3": "CPV",
    "locationTranslations": {
      "de": "Kap Verde",
      "en": "Cape Verde",
      "fr": "Cap-Vert",
      "tr": "Yeşil Burun Adaları"
    },
    "name": "Cape Verde",
    "native": "Cabo Verde",
    "phoneCode": "238",
    "region": "Africa",
    "subregion": "Western Africa",
    "updatedAt": 1657792795147
  },
  {
    "capital": "Athens",
    "createdAt": 1604406817998,
    "currency": "EUR",
    "currencyCode": "EUR",
    "currencySymbol": "€",
    "deleted": false,
    "emoji": "🇬🇷",
    "emojiString": "U+1F1EC U+1F1F7",
    "id": "95690bec-7483-4618-9ae5-6b73d8a8a962",
    "iso2": "GR",
    "iso3": "GRC",
    "locationTranslations": {
      "de": "Griechenland",
      "en": "Greece",
      "fr": "Grèce",
      "tr": "Yunanistan"
    },
    "name": "Greece",
    "native": "Ελλάδα",
    "phoneCode": "30",
    "region": "Europe",
    "subregion": "Southern Europe",
    "updatedAt": 1657792807592
  },
  {
    "capital": "Lusaka",
    "createdAt": 1604406818002,
    "currency": "ZMW",
    "currencyCode": "ZMW",
    "currencySymbol": "ZK",
    "deleted": false,
    "emoji": "🇿🇲",
    "emojiString": "U+1F1FF U+1F1F2",
    "id": "90d87323-2bd5-452c-bc7c-aaa15a89e50b",
    "iso2": "ZM",
    "iso3": "ZMB",
    "locationTranslations": {
      "de": "Sambia",
      "en": "Zambia",
      "fr": "Zambie",
      "tr": "Zambiya"
    },
    "name": "Zambia",
    "native": "Zambia",
    "phoneCode": "260",
    "region": "Africa",
    "subregion": "Eastern Africa",
    "updatedAt": 1657792802073
  },
  {
    "capital": "Harare",
    "createdAt": 1604406818002,
    "currency": "ZWL",
    "currencyCode": "ZWL",
    "currencySymbol": "Z$",
    "deleted": false,
    "emoji": "🇿🇼",
    "emojiString": "U+1F1FF U+1F1FC",
    "id": "42e7550a-a99d-4ee4-858a-666565aa6f0e",
    "iso2": "ZW",
    "iso3": "ZWE",
    "locationTranslations": {
      "de": "Simbabwe",
      "en": "Zimbabwe",
      "fr": "Zimbabwe",
      "tr": "Zimbabve"
    },
    "name": "Zimbabwe",
    "native": "Zimbabwe",
    "phoneCode": "263",
    "region": "Africa",
    "subregion": "Eastern Africa",
    "updatedAt": 1657792808144
  }
]